/* generated by scripts/build_studio_section.py — edit preview/studio.template.html */
(function () {
'use strict';
/* ============================================================
   Data — mirrors the Shopify theme
   ------------------------------------------------------------
   Prices come from the Shopify variants (assets/usipic-perimeter-variants.json)
   Sizes / frame codes come from sections/usipic-poster-configurator.liquid
   ============================================================ */
/* Prices come from the Shopify variants (522 per frame), not from a per-size
   matrix: the theme has one variant per size. Loaded from the boot JSON. */
let VARIANT_MAP = null;
const VARIANT_BOOT = window.USIPIC_STUDIO_BOOT || {};

const SIZES = {
  square:    ['16x16','20x20','24x24'],
  portrait:  ['8x10','12x16','12x18','16x20','12x24','16x24','20x24','16x30','20x30','24x30','18x32','18x36','24x36','28x35','30x40','32x40'],
  landscape: ['10x8','16x12','18x12','20x16','24x12','24x16','24x20','30x16','30x20','30x24','32x18','36x18','36x24','35x28','40x30','40x32'],
};
/* Canonical product sizes, de-duplicated (12x16 and 16x12 are the same frame). */
const SIZE_PRESETS = (() => {
  const seen = new Set(), out = [];
  ['square', 'portrait', 'landscape'].forEach(g => SIZES[g].forEach(s => {
    const [w, h] = s.split('x').map(Number);
    const key = Math.min(w, h) + 'x' + Math.max(w, h);
    if (seen.has(key)) return;
    seen.add(key);
    out.push(`${w}x${h}`);
  }));
  return out;
})();

const LONG_MIN = 10, LONG_MAX = 40, SHORT_MIN = 8, SHORT_MAX = 32;

/* Frame mouldings. `face` = visible face width (in), `depth` = how far the
   moulding stands off the wall (in). Layers run outer → inner. */
const FRAMES = [
  { code:'F35', name:'Walnut Beaded Frame', material:'Wood · gold bead', face:1.40, depth:1.14,
    layers:[{w:1.16,c:0x57301f,r:0.46,m:0.00},{w:0.24,c:0x241a15,r:0.75,m:0.00}] },
  { code:'F36', name:'Slim Black Frame', material:'Wood · metal edge', face:1.15, depth:1.00,
    layers:[{w:0.05,c:0xc1c3c4,r:0.35,m:0.65},{w:0.90,c:0x202124,r:0.70,m:0.00},{w:0.20,c:0x929493,r:0.42,m:0.40}] },
  { code:'F66', name:'Rustic Espresso Frame', material:'Wood · distressed gold inner trim', face:1.25, depth:1.04,
    layers:[{w:1.04,c:0x40302a,r:0.69,m:0.00},{w:0.21,c:0x211b18,r:0.74,m:0.00}] },
  { code:'F84', name:'Ornate Bronze Gold Frame', material:'Poly · ornate bronze and gold', face:1.20, depth:1.16,
    layers:[{w:0.24,c:0xb69259,r:0.40,m:0.48},{w:0.32,c:0xd2ad6f,r:0.38,m:0.55},{w:0.42,c:0x806044,r:0.55,m:0.24},{w:0.22,c:0xc79e59,r:0.42,m:0.50}] },
  { code:'F85', name:'Wide Antique Black Gold Frame', material:'Poly · black and antique gold', face:1.24, depth:1.13,
    layers:[{w:0.17,c:0xc5a06a,r:0.40,m:0.42},{w:0.30,c:0x25201b,r:0.62,m:0.10},{w:0.61,c:0xd8bb8b,r:0.39,m:0.38},{w:0.16,c:0xa98554,r:0.47,m:0.32}] },
  /* F82 replaced L05 (discontinued). Same moulding profile + ornament as F85 (wide antique
     black gold, photo-matched); only the name and thumbnail differ. */
  { code:'F82', name:'Slim Antique Black Gold Frame', material:'Poly · antique gold', face:1.24, depth:1.13,
    layers:[{w:0.17,c:0xb08a52,r:0.40,m:0.42},{w:0.30,c:0x1d1813,r:0.62,m:0.10},{w:0.61,c:0xcfa464,r:0.39,m:0.38},{w:0.16,c:0xa9854f,r:0.47,m:0.32}] },
  { code:'F91', name:'Bronze Wood Frame', material:'Wood · bronze finish', face:1.35, depth:0.484,
    layers:[{w:1.06,c:0x504538,r:0.63,m:0.10},{w:0.29,c:0x42372d,r:0.68,m:0.06}] },
  { code:'F92', name:'Classic White Frame', material:'Wood · classic white', face:1.35, depth:0.484,
    layers:[{w:1.06,c:0xf4f5f4,r:0.63,m:0.00},{w:0.29,c:0xe6e8e8,r:0.68,m:0.00}] },
  { code:'F93', name:'Black Gold Accent Frame', material:'Wood · black finish with gold inner trim', face:1.35, depth:0.484,
    layers:[{w:1.13,c:0x24262a,r:0.54,m:0.08},{w:0.22,c:0xc79845,r:0.37,m:0.48}] },
  { code:'F94', name:'Black Silver Accent Frame', material:'Wood · black finish with silver inner trim', face:1.35, depth:0.484,
    layers:[{w:1.13,c:0x24262a,r:0.54,m:0.08},{w:0.22,c:0xc1c9ce,r:0.38,m:0.55}] },
  { code:'F97', name:'Ornate Gold Frame', material:'Wood · ornate gilded finish', face:1.48, depth:0.66,
    layers:[{w:0.22,c:0xf0cb5e,r:0.34,m:0.63},{w:0.31,c:0xe2af36,r:0.36,m:0.57},
            {w:0.66,c:0xf2d376,r:0.42,m:0.43},{w:0.29,c:0xd7a92e,r:0.39,m:0.55}] },
  { code:'F98', name:'Ornate Silver Frame', material:'Wood · ornate silver finish', face:1.48, depth:0.66,
    layers:[{w:0.22,c:0xe6eaee,r:0.34,m:0.63},{w:0.31,c:0xbac1c8,r:0.36,m:0.57},
            {w:0.66,c:0xf0f2f4,r:0.42,m:0.43},{w:0.29,c:0xaeb6be,r:0.39,m:0.55}] },
  { code:'L01', name:'Natural Oak Frame', material:'Wood · natural oak', face:0.30, depth:3.00, float:true,
    layers:[{w:0.30,c:0xe8c69e,r:0.72,m:0.00}] },
  { code:'L08', name:'Charcoal Wood Frame', material:'Wood · charcoal brown grain', face:0.30, depth:3.00, float:true,
    layers:[{w:0.30,c:0x403831,r:0.78,m:0.00}] },
  { code:'L09', name:'Black Wood Frame', material:'Wood · black grain', face:0.30, depth:3.00, float:true,
    layers:[{w:0.30,c:0x151719,r:0.82,m:0.00}] },
];
const FRAME_BY_CODE = Object.fromEntries(FRAMES.map(f => [f.code, f]));

/* ---------------- state ---------------- */
const state = {
  size:'24x16',          // "WxH" in inches, edited directly in the Size step
  frame:'F35',
  art:{ kind:'sample', key:'sunrise' },
  artFile:null,
  artName:'',
};
const SIZE_RE = /^(\d+)x(\d+)$/;

/* ---------------- price helpers (ported from usipic-poster-configurator.js) ---------------- */
const SHORT_COUNT = SHORT_MAX - SHORT_MIN + 1;
function priceEntry(size, code){
  if (!VARIANT_MAP) return null;
  const m = SIZE_RE.exec(size);
  if (!m) return null;
  const w = parseInt(m[1], 10), h = parseInt(m[2], 10);
  const lng = Math.max(w, h), sht = Math.min(w, h);
  if (lng < LONG_MIN || lng > LONG_MAX || sht < SHORT_MIN || sht > SHORT_MAX) return null;
  const frame = VARIANT_MAP.frames[code];
  if (!frame) return null;
  const slot = frame.v[(lng - LONG_MIN) * SHORT_COUNT + (sht - SHORT_MIN)];
  return slot ? { total: slot[1] / 100, variantId: slot[0] } : null;
}
const money = n => '$' + Number(n).toFixed(2);

/* ============================================================
   three.js — vendored global build, no CDN
   ============================================================ */
if (!window.THREE) {
  document.getElementById('boot').classList.add('is-done');
  document.getElementById('fatal').classList.add('is-on');
  document.getElementById('fatal-msg').textContent =
    'The 3D engine did not load. Please refresh the page.';
  throw new Error('three.global.js not found');
}
const THREE = window.THREE;

const canvas = document.getElementById('gl');
const stageEl = document.getElementById('stage');

const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:true, powerPreference:'high-performance' });
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.0;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setClearAlpha(0);

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(34, 1, 0.5, 6000);
camera.position.set(-40, 12, 95);

/* ---- orbit controls ----
   A trimmed replacement for three/addons/controls/OrbitControls.js so the page
   needs nothing but the core library. Same surface the page actually uses:
   damping, pan disabled, clamped polar/azimuth range, clamped distance, and a
   plain Vector3 `target` that the camera presets lerp directly. */
class OrbitControls {
  constructor(object, domElement){
    this.object = object;
    this.domElement = domElement;
    this.target = new THREE.Vector3();

    this.enabled = true;
    this.enableDamping = false;
    this.dampingFactor = 0.08;
    this.rotateSpeed = 1;
    this.zoomSpeed = 1;
    this.minDistance = 0;
    this.maxDistance = Infinity;
    this.minPolarAngle = 0;
    this.maxPolarAngle = Math.PI;
    this.minAzimuthAngle = -Infinity;
    this.maxAzimuthAngle = Infinity;

    this._spherical = new THREE.Spherical();
    this._sphericalDelta = new THREE.Spherical(0, 0, 0);
    this._scale = 1;
    this._offset = new THREE.Vector3();
    this._pointers = new Map();
    this._pinch = 0;

    this._onDown = this._onDown.bind(this);
    this._onMove = this._onMove.bind(this);
    this._onUp = this._onUp.bind(this);
    this._onWheel = this._onWheel.bind(this);

    domElement.addEventListener('pointerdown', this._onDown);
    domElement.addEventListener('pointermove', this._onMove);
    domElement.addEventListener('pointerup', this._onUp);
    domElement.addEventListener('pointercancel', this._onUp);
    domElement.addEventListener('wheel', this._onWheel, { passive: false });
    domElement.style.touchAction = 'none';
  }

  _onDown(e){
    if (!this.enabled) return;
    try { this.domElement.setPointerCapture(e.pointerId); } catch (_) {}
    this._pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (this._pointers.size === 2) this._pinch = this._pinchDistance();
  }

  _onMove(e){
    if (!this.enabled) return;
    const prev = this._pointers.get(e.pointerId);
    if (!prev) return;
    const dx = e.clientX - prev.x;
    const dy = e.clientY - prev.y;
    prev.x = e.clientX;
    prev.y = e.clientY;

    if (this._pointers.size === 1){
      const h = this.domElement.clientHeight || 1;
      this._sphericalDelta.theta -= (2 * Math.PI * dx / h) * this.rotateSpeed;
      this._sphericalDelta.phi -= (2 * Math.PI * dy / h) * this.rotateSpeed;
    } else if (this._pointers.size === 2){
      const d = this._pinchDistance();
      if (this._pinch > 0 && d > 0) this._scale *= this._pinch / d;
      this._pinch = d;
    }
  }

  _onUp(e){
    this._pointers.delete(e.pointerId);
    if (this._pointers.size < 2) this._pinch = 0;
    try { this.domElement.releasePointerCapture(e.pointerId); } catch (_) {}
  }

  _onWheel(e){
    if (!this.enabled) return;
    e.preventDefault();
    /* scroll up (deltaY < 0) zooms in: scale < 1 shrinks the orbit radius */
    this._scale *= Math.pow(0.92, this.zoomSpeed * (e.deltaY < 0 ? 1 : -1));
  }

  _pinchDistance(){
    const pts = Array.from(this._pointers.values());
    if (pts.length < 2) return 0;
    return Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
  }

  update(){
    this._offset.copy(this.object.position).sub(this.target);
    this._spherical.setFromVector3(this._offset);

    const damp = this.enableDamping ? this.dampingFactor : 1;
    this._spherical.theta += this._sphericalDelta.theta * damp;
    this._spherical.phi += this._sphericalDelta.phi * damp;
    this._spherical.radius *= 1 + (this._scale - 1) * damp;

    this._spherical.theta = Math.max(this.minAzimuthAngle, Math.min(this.maxAzimuthAngle, this._spherical.theta));
    this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
    this._spherical.makeSafe();
    this._spherical.radius = Math.max(this.minDistance, Math.min(this.maxDistance, this._spherical.radius));

    this._offset.setFromSpherical(this._spherical);
    this.object.position.copy(this.target).add(this._offset);
    this.object.lookAt(this.target);

    if (this.enableDamping){
      const keep = 1 - this.dampingFactor;
      this._sphericalDelta.theta *= keep;
      this._sphericalDelta.phi *= keep;
      this._scale = 1 + (this._scale - 1) * keep;
      if (Math.abs(this._sphericalDelta.theta) < 1e-5) this._sphericalDelta.theta = 0;
      if (Math.abs(this._sphericalDelta.phi) < 1e-5) this._sphericalDelta.phi = 0;
      if (Math.abs(this._scale - 1) < 1e-5) this._scale = 1;
    } else {
      this._sphericalDelta.theta = 0;
      this._sphericalDelta.phi = 0;
      this._scale = 1;
    }
  }

  dispose(){
    this.domElement.removeEventListener('pointerdown', this._onDown);
    this.domElement.removeEventListener('pointermove', this._onMove);
    this.domElement.removeEventListener('pointerup', this._onUp);
    this.domElement.removeEventListener('pointercancel', this._onUp);
    this.domElement.removeEventListener('wheel', this._onWheel);
  }
}

/* ---- studio environment ----
   Replaces three/addons/environments/RoomEnvironment.js. A painted equirect
   gradient with two soft window highlights, run through PMREM: smooth studio
   reflections for the gilded and silver mouldings, and it costs no dependency. */
function makeStudioEnvironment(){
  const c = document.createElement('canvas');
  c.width = 512;
  c.height = 256;
  const g = c.getContext('2d');

  const sky = g.createLinearGradient(0, 0, 0, 256);
  sky.addColorStop(0.00, '#ffffff');
  sky.addColorStop(0.28, '#f4f1ec');
  sky.addColorStop(0.50, '#d9d4cc');
  sky.addColorStop(0.70, '#a5a099');
  sky.addColorStop(1.00, '#57544f');
  g.fillStyle = sky;
  g.fillRect(0, 0, 512, 256);

  const highlight = (x, y, r, alpha) => {
    const grad = g.createRadialGradient(x, y, 0, x, y, r);
    grad.addColorStop(0, 'rgba(255,255,255,' + alpha + ')');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = grad;
    g.fillRect(x - r, y - r, r * 2, r * 2);
  };
  highlight(118, 82, 132, 0.95);
  highlight(356, 66, 92, 0.55);

  /* darker floor bounce so the underside of a moulding is not flat */
  const bounce = g.createLinearGradient(0, 188, 0, 256);
  bounce.addColorStop(0, 'rgba(42,40,37,0)');
  bounce.addColorStop(1, 'rgba(42,40,37,0.60)');
  g.fillStyle = bounce;
  g.fillRect(0, 188, 512, 68);

  const tex = new THREE.CanvasTexture(c);
  tex.mapping = THREE.EquirectangularReflectionMapping;
  tex.colorSpace = THREE.SRGBColorSpace;

  const pmrem = new THREE.PMREMGenerator(renderer);
  const env = pmrem.fromEquirectangular(tex).texture;
  pmrem.dispose();
  tex.dispose();
  return env;
}

const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.dampingFactor = 0.075;
controls.enablePan = false;
controls.rotateSpeed = 0.75;
controls.zoomSpeed = 0.85;
controls.minPolarAngle = Math.PI * 0.22;
controls.maxPolarAngle = Math.PI * 0.58;
controls.minAzimuthAngle = -0.95;
controls.maxAzimuthAngle = 0.95;

scene.environment = makeStudioEnvironment();
scene.environmentIntensity = 0.5;

/* ---- lights: soft gallery setup, tuned once ---- */
const hemi = new THREE.HemisphereLight(0xffffff, 0x8f8a82, 0.52);
scene.add(hemi);

const key = new THREE.DirectionalLight(0xfff3e2, 1.05);
key.castShadow = true;
key.shadow.mapSize.set(2048, 2048);
key.shadow.bias = -0.0008;
key.shadow.normalBias = 0.6;
key.shadow.radius = 3.5;
scene.add(key, key.target);

const fill = new THREE.DirectionalLight(0xdfe8ff, 0.42);
scene.add(fill, fill.target);

/* ---- helper textures ---- */
function noiseTexture(size = 256){
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d');
  const img = g.createImageData(size, size);
  let s = 12345;
  const rnd = () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296;
  for (let i = 0; i < size * size; i++){
    const v = 226 + Math.round(rnd() * 29);
    img.data[i*4] = img.data[i*4+1] = img.data[i*4+2] = v;
    img.data[i*4+3] = 255;
  }
  g.putImageData(img, 0, 0);
  const t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  return t;
}
const roughnessNoise = noiseTexture();
roughnessNoise.repeat.set(0.55, 0.55);

/* Soft shadow card: a blurred ring hugging the frame silhouette, used twice —
   a tight contact halo and a wider, offset drop shadow behind the frame. */
function softShadowTexture(W, H, openingW, openingH, pad, blurIn){
  const scale = 4;        // px per inch
  const w = Math.max(64, Math.round((W + pad) * scale));
  const h = Math.max(64, Math.round((H + pad) * scale));
  const sharp = document.createElement('canvas'); sharp.width = w; sharp.height = h;
  const sg = sharp.getContext('2d');
  const cx = w / 2, cy = h / 2;
  const ringW = (W + 1.5) * scale / 2, ringH = (H + 1.5) * scale / 2;
  sg.fillStyle = '#000';
  sg.beginPath();
  sg.rect(cx - ringW, cy - ringH, ringW * 2, ringH * 2);
  sg.rect(cx - openingW * scale / 2, cy - openingH * scale / 2, openingW * scale, openingH * scale);
  sg.fill('evenodd');
  const soft = document.createElement('canvas'); soft.width = w; soft.height = h;
  const fg = soft.getContext('2d');
  fg.filter = `blur(${Math.round(blurIn * scale)}px)`;
  fg.drawImage(sharp, 0, 0);
  const t = new THREE.CanvasTexture(soft);
  t.colorSpace = THREE.SRGBColorSpace;
  return t;
}
function shadowCard(W, H, openingW, openingH, pad, blurIn, opacity, ox, oy){
  const mesh = new THREE.Mesh(
    new THREE.PlaneGeometry(W + pad, H + pad),
    new THREE.MeshBasicMaterial({
      map: softShadowTexture(W, H, openingW, openingH, pad, blurIn),
      transparent: true, opacity, depthWrite: false,
    })
  );
  mesh.position.set(ox, oy, 0.03);
  return mesh;
}

/* Ring geometry: outer rect with a rectangular hole, extruded to `depth`. */
function ringGeometry(outerW, outerH, innerW, innerH, depth, bevel){
  const shape = new THREE.Shape();
  shape.moveTo(-outerW/2, -outerH/2);
  shape.lineTo( outerW/2, -outerH/2);
  shape.lineTo( outerW/2,  outerH/2);
  shape.lineTo(-outerW/2,  outerH/2);
  shape.closePath();
  const hole = new THREE.Path();
  hole.moveTo(-innerW/2, -innerH/2);
  hole.lineTo(-innerW/2,  innerH/2);
  hole.lineTo( innerW/2,  innerH/2);
  hole.lineTo( innerW/2, -innerH/2);
  hole.closePath();
  shape.holes.push(hole);
  const geo = new THREE.ExtrudeGeometry(shape, {
    depth, bevelEnabled: bevel > 0, bevelThickness: bevel, bevelSize: bevel,
    bevelSegments: 2, curveSegments: 1, steps: 1,
  });
  geo.computeVertexNormals();
  return geo;
}

/* F35 has a carved walnut face and an inset row of individual gilt beads.
   The four rails share one profile, so every size keeps proper mitred corners. */
/* Moulding cross-sections: {r: inset from the outer edge (in), z: depth (in),
   c: vertex colour}. Injected from preview/frame-profiles.json so the shapes and
   colours can be edited as data — see the Frame lab in the preview page. */
const PROFILES = {"F35":[{"r":0.0,"z":0.6,"c":4141098},{"r":0.0,"z":0.96,"c":4930098},{"r":0.01,"z":1.0,"c":5784632},{"r":0.03,"z":1.03,"c":6507581},{"r":0.06,"z":1.04,"c":6967615},{"r":0.12,"z":1.02,"c":7164736},{"r":0.2,"z":0.99,"c":7296321},{"r":0.3,"z":0.96,"c":7362114},{"r":0.42,"z":0.93,"c":7230529},{"r":0.54,"z":0.91,"c":7033408},{"r":0.66,"z":0.9,"c":6836287},{"r":0.76,"z":0.9,"c":6967872},{"r":0.84,"z":0.91,"c":7296579},{"r":0.88,"z":0.92,"c":7625285},{"r":0.92,"z":0.9,"c":7164737},{"r":0.96,"z":0.86,"c":6244410},{"r":1.0,"z":0.83,"c":5521460},{"r":1.06,"z":0.81,"c":5127217},{"r":1.1,"z":0.83,"c":5784376},{"r":1.14,"z":0.84,"c":6310201},{"r":1.16,"z":0.84,"c":6507580}],"F36":[{"r":0,"z":0.62,"c":1052947},{"r":0,"z":0.92,"c":1645084},{"r":0.04,"z":0.99,"c":2566186},{"r":0.09,"z":1,"c":3355703},{"r":0.16,"z":0.99,"c":2368807},{"r":0.7,"z":0.99,"c":1908256},{"r":0.85,"z":0.96,"c":1776670},{"r":0.95,"z":0.87,"c":1447705}],"F66":[{"r":0.0,"z":1.0,"c":5915699},{"r":0.03,"z":0.988,"c":5521455},{"r":0.09,"z":0.962,"c":4535337},{"r":0.17,"z":0.928,"c":3812386},{"r":0.28,"z":0.898,"c":3549471},{"r":0.42,"z":0.876,"c":3352093},{"r":0.56,"z":0.864,"c":3220505},{"r":0.7,"z":0.866,"c":3352092},{"r":0.82,"z":0.886,"c":3746592},{"r":0.91,"z":0.92,"c":4535335},{"r":0.96,"z":0.955,"c":5455919},{"r":0.99,"z":0.975,"c":5521455},{"r":1.01,"z":0.972,"c":5455919},{"r":1.03,"z":0.94,"c":4535335},{"r":1.06,"z":0.895,"c":3483679},{"r":1.1,"z":0.862,"c":2365973},{"r":1.14,"z":0.86,"c":1774352},{"r":1.175,"z":0.872,"c":2234645},{"r":1.2,"z":0.895,"c":2892059}],"F66_SIDE":[{"r":0.0,"z":1.0,"c":3023905},{"r":0.02,"z":0.94,"c":2826526},{"r":0.026,"z":0.88,"c":2760733},{"r":0.026,"z":0.7,"c":2629147},{"r":0.026,"z":0.4,"c":2629147},{"r":0.02,"z":0.12,"c":2760733},{"r":0.0,"z":0.0,"c":3023905}],"F84":[{"r":0,"z":0.65,"c":16777215},{"r":0,"z":1.04,"c":16777215},{"r":0.04,"z":1.13,"c":16777215},{"r":0.11,"z":1.16,"c":16777215},{"r":0.23,"z":1.13,"c":16777215},{"r":0.27,"z":1.02,"c":16777215},{"r":0.32,"z":1.1,"c":16777215},{"r":0.47,"z":1.09,"c":16777215},{"r":0.54,"z":0.99,"c":16777215},{"r":0.61,"z":0.82,"c":16777215},{"r":0.78,"z":0.79,"c":16777215},{"r":0.91,"z":0.88,"c":16777215},{"r":0.98,"z":1,"c":16777215},{"r":1.12,"z":1,"c":16777215},{"r":1.17,"z":0.9,"c":16777215},{"r":1.2,"z":0.82,"c":16777215}],"F97":[{"r":0,"z":0.65,"c":16777215},{"r":0,"z":1.05,"c":16777215},{"r":0.03,"z":1.16,"c":16777215},{"r":0.09,"z":1.2,"c":16777215},{"r":0.15,"z":1.19,"c":16777215},{"r":0.18,"z":1.17,"c":16777215},{"r":0.21,"z":1.15,"c":16777215},{"r":0.24,"z":1.15,"c":16777215},{"r":0.28,"z":1.19,"c":16777215},{"r":0.53,"z":1.18,"c":16777215},{"r":0.58,"z":1.13,"c":16777215},{"r":0.63,"z":0.96,"c":16777215},{"r":0.69,"z":0.83,"c":16777215},{"r":0.77,"z":0.73,"c":16777215},{"r":0.89,"z":0.69,"c":16777215},{"r":1.02,"z":0.7,"c":16777215},{"r":1.12,"z":0.77,"c":16777215},{"r":1.19,"z":0.88,"c":16777215},{"r":1.26,"z":1.06,"c":16777215},{"r":1.39,"z":1.07,"c":16777215},{"r":1.43,"z":1.02,"c":16777215},{"r":1.48,"z":0.86,"c":16777215}],"L01_OAK":[{"r":0,"z":0,"c":14992028},{"r":0,"z":3,"c":16777215},{"r":0.3,"z":3,"c":16777215},{"r":0.3,"z":0,"c":14135690}],"L08_DARK_WOOD":[{"r":0,"z":0,"c":6774874},{"r":0,"z":1.12,"c":9208957},{"r":0.1,"z":1.23,"c":10195851},{"r":0.25,"z":1.48,"c":11709348},{"r":0.48,"z":1.66,"c":14736856},{"r":0.68,"z":1.7,"c":16118768},{"r":0.68,"z":0,"c":5261893}],"F85":[{"r":0,"z":0.65,"c":16777215},{"r":0,"z":1.02,"c":16777215},{"r":0.04,"z":1.1,"c":16777215},{"r":0.12,"z":1.13,"c":16777215},{"r":0.18,"z":1.04,"c":16777215},{"r":0.22,"z":0.98,"c":16777215},{"r":0.43,"z":0.98,"c":16777215},{"r":0.48,"z":1.03,"c":16777215},{"r":0.54,"z":1.01,"c":16777215},{"r":0.65,"z":0.89,"c":16777215},{"r":0.81,"z":0.78,"c":16777215},{"r":0.94,"z":0.79,"c":16777215},{"r":1.06,"z":0.91,"c":16777215},{"r":1.1,"z":1,"c":16777215},{"r":1.2,"z":0.99,"c":16777215},{"r":1.24,"z":0.85,"c":16777215}],"F91":[{"r":0,"z":0.68,"c":3287844},{"r":0,"z":1,"c":5063221},{"r":0.03,"z":1.07,"c":6772288},{"r":0.08,"z":1.11,"c":7035203},{"r":0.15,"z":1.11,"c":6443583},{"r":0.22,"z":1.07,"c":5851963},{"r":0.27,"z":1.01,"c":4536881},{"r":0.3,"z":0.94,"c":3419688},{"r":0.32,"z":0.93,"c":3156518},{"r":0.35,"z":1.01,"c":5194292},{"r":0.38,"z":1.075,"c":7035204},{"r":0.41,"z":1.09,"c":6574911},{"r":0.44,"z":1.05,"c":4208430},{"r":0.47,"z":0.93,"c":3156775},{"r":0.5,"z":0.92,"c":3353897},{"r":0.53,"z":1.01,"c":5326134},{"r":0.56,"z":1.065,"c":7166790},{"r":0.59,"z":1.07,"c":6837825},{"r":0.62,"z":1.02,"c":4536623},{"r":0.66,"z":0.9,"c":4142639},{"r":0.7,"z":0.866,"c":5983035},{"r":1,"z":0.819,"c":5588278},{"r":1.12,"z":0.8,"c":4799280},{"r":1.18,"z":0.812,"c":5983036},{"r":1.24,"z":0.857,"c":7889482},{"r":1.3,"z":0.887,"c":9072722},{"r":1.33,"z":0.877,"c":7361596},{"r":1.35,"z":0.825,"c":3681316},{"r":1.35,"z":0.68,"c":2958623}],"overrides":{}};

/* Mitre joint: width of the flat either side of the seam, how deep it cuts, and
   how much darker the seam columns are drawn. The Frame lab edits these live. */
const SEAM = { depth: 0.012, width: 0.022, shade: 0.5 };

const F35_PROFILE = PROFILES.F35;
const F36_PROFILE = PROFILES.F36;
const F66_PROFILE = PROFILES.F66;
/* The outside wall recedes in its middle, then returns near the back. */
const F66_SIDE_PROFILE = PROFILES.F66_SIDE;
const F84_PROFILE = PROFILES.F84;
const F97_PROFILE = PROFILES.F97;
const F97_DEPTH_SCALE = 0.55;
const F97_SHALLOW_PROFILE = F97_PROFILE.map(p => ({...p,z:p.z*F97_DEPTH_SCALE}));
const F97_BACK_Z = -0.28;
const F97_MITER_OFFSETS = [
  0,0,0,0,0, 0.05,0.09,0.02,0,0,0.02,
  -0.03,-0.07,-0.11,-0.14,-0.14,-0.10,-0.06,0,0,0,0
];
const F97_SIDE_PROFILE = [
  {r:0.00,z:0.65*F97_DEPTH_SCALE,c:0xbd8b2c},
  {r:0.000,z:0.31,c:0xe8c76a},
  {r:0.080,z:0.25,c:0xa36f27},
  {r:0.150,z:0.20,c:0x84571d},
  {r:0.120,z:0.16,c:0xca9836},
  {r:0.060,z:0.07,c:0xb68129},
  {r:-0.280,z:0.04,c:0xb68129},
  {r:-0.280,z:F97_BACK_Z,c:0x865b19},
];
const L01_OAK_PROFILE = PROFILES.L01_OAK;
const L08_DARK_WOOD_PROFILE = PROFILES.L08_DARK_WOOD;
const L01_SILVER_SIDE_COLORS = [
  0xb1b7bd,0xe9edf2,0x9ca2aa,0x7d858e,
  0xd3d7dd,0xb5bbc2,0xa4abb4,0x747b84,
];
const F85_PROFILE = PROFILES.F85;
/* An ogee curve forms F85's outside thickness; its last portion stays
   straight through the extended section at the back. */
const F85_SIDE_PROFILE = (() => {
  const profile=[];
  const addCurve=(p0,p1,p2,p3,firstColor,lastColor,skipStart=false) => {
    const from=new THREE.Color(firstColor), to=new THREE.Color(lastColor);
    for(let i=skipStart?1:0;i<=10;i++){
      const t=i/10, q=1-t;
      profile.push({
        r:q*q*q*p0[0]+3*q*q*t*p1[0]+3*q*t*t*p2[0]+t*t*t*p3[0],
        z:q*q*q*p0[1]+3*q*q*t*p1[1]+3*q*t*t*p2[1]+t*t*t*p3[1],
        c:from.clone().lerp(to,t).getHex(),
      });
    }
  };
  addCurve([0,1.02],[-0.005,0.92],[-0.07,0.78],[-0.14,0.78],
           0xc6a67b,0x947653);
  addCurve([-0.14,0.78],[-0.21,0.78],[-0.23,0.53],[-0.23,0.48],
           0x947653,0x6f533b,true);
  profile.push({r:-0.23,z:0.00,c:0x58402e});
  return profile;
})();
const F91_PROFILE = PROFILES.F91;
const F91_DEPTH_SCALE = 0.418;
const F91_SHALLOW_PROFILE = F91_PROFILE.map(p => ({...p,z:p.z*F91_DEPTH_SCALE}));
const F92_WHITE_TONES = [
  0xdedfde,0xf0f1f0,0xf8f9f8,0xffffff,0xf9faf9,0xf1f2f1,
  0xe8eae9,0xd8dad9,0xd3d5d4,0xe9ebea,0xf8f9f8,0xffffff,
  0xe8eae9,0xd2d4d3,0xd0d2d1,0xe8eae9,0xf8f9f8,0xffffff,
  0xe6e8e7,0xdadbd9,0xf0f1f0,0xf4f5f4,0xe4e6e5,
  0xe8eae9,0xf5f6f5,0xffffff,0xf2f3f2,0xdfe1e0,0xd9dbda
];
const F92_WHITE_PROFILE = F91_SHALLOW_PROFILE.map((p,i) => ({...p,c:F92_WHITE_TONES[i]}));
const F93_BLACK_GOLD_TONES = [
  0x101114,0x1c1e22,0x292c31,0x30343a,0x25282e,0x1c1f24,
  0x15181d,0x090b0e,0x080a0d,0x1c2026,0x2d323a,0x343941,
  0x1b1e23,0x090b0e,0x080a0d,0x1c2026,0x2b3038,0x32373f,
  0x1a1d22,0x111419,0x1b1e23,0x24282d,0x1c2025,
  0x76501f,0x976826,0xd2a247,0xf3cb6b,0xc08b36,0x76501f
];
const F93_BLACK_GOLD_PROFILE = F91_SHALLOW_PROFILE.map((p,i) => ({...p,c:F93_BLACK_GOLD_TONES[i]}));
const F94_SILVER_TONES = [0x6e777e,0x9ca8af,0xc5d0d5,0xecf2f2,0xaebac0,0x646e75];
const F94_BLACK_SILVER_TONES = F93_BLACK_GOLD_TONES.slice(0,-F94_SILVER_TONES.length).concat(F94_SILVER_TONES);
const F94_BLACK_SILVER_PROFILE = F91_SHALLOW_PROFILE.map((p,i) => ({...p,c:F94_BLACK_SILVER_TONES[i]}));

function f35WoodTexture(){
  const c = document.createElement('canvas');
  c.width = 1024; c.height = 256;
  const g = c.getContext('2d');
  let seed = 351447;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  g.fillStyle = '#cfc6bb';
  g.fillRect(0, 0, c.width, c.height);

  /* faint unevenness only: big soft blotches are what made it read as leather */
  for (let i = 0; i < 26; i++){
    const x = rnd() * c.width, y = rnd() * c.height;
    const rad = 60 + rnd() * 150;
    const dark = rnd() < 0.6;
    const grad = g.createRadialGradient(x, y, 0, x, y, rad);
    const a = 0.03 + rnd() * 0.05;
    grad.addColorStop(0, dark ? `rgba(40,22,13,${a})` : `rgba(240,226,205,${a})`);
    grad.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = grad;
    g.beginPath();
    g.arc(x, y, rad, 0, Math.PI * 2);
    g.fill();
  }

  /* long grain streaks along the moulding — the direction is what reads as wood */
  for (let i = 0; i < 520; i++){
    const y = rnd() * c.height, x = rnd() * c.width;
    const length = 120 + rnd() * 800;
    g.strokeStyle = rnd() < 0.8 ? `rgba(32,17,10,${0.03 + rnd() * 0.15})`
                                : `rgba(255,232,196,${0.03 + rnd() * 0.10})`;
    g.lineWidth = 0.2 + rnd() * 1.0;
    g.beginPath();
    g.moveTo(x, y);
    g.bezierCurveTo(x + length * .33, y + rnd() * 2 - 1,
                    x + length * .66, y + rnd() * 2 - 1, x + length, y);
    g.stroke();
  }

  /* pores, also running with the grain */
  for (let i = 0; i < 190; i++){
    const y = rnd() * c.height, x = rnd() * c.width;
    g.strokeStyle = `rgba(22,12,7,${0.10 + rnd() * 0.22})`;
    g.lineWidth = 0.3 + rnd() * 0.5;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + 20 + rnd() * 120, y + rnd() * 1.2 - 0.6);
    g.stroke();
  }
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f35Grain = f35WoodTexture();

/* Photo-derived wood maps for F35: cropped off the product shot, de-lit, tiled
   with a mirror seam. The theme passes asset_url values through its boot JSON
   (assets/*.js is not Liquid-rendered, so the tags cannot live in here); the
   standalone preview gets plain relative paths injected by preview/build.py. */
const WOOD_MAPS = (window.USIPIC_STUDIO_BOOT && window.USIPIC_STUDIO_BOOT.wood) || {
  color: '',
  normal: '',
  rough: '',
};
const WOOD_STRIP_INCHES = 2.9;   // how much moulding the crop covers
let woodMaps = null;
let woodMapsLoading = false;
function ensureWoodMaps(){
  if (woodMaps || woodMapsLoading || !WOOD_MAPS.color || WOOD_MAPS.color.startsWith('__')) return;
  woodMapsLoading = true;
  const loader = new THREE.TextureLoader();
  const load = url => new Promise((resolve, reject) => loader.load(url, resolve, undefined, reject));
  Promise.all([load(WOOD_MAPS.color), load(WOOD_MAPS.normal), load(WOOD_MAPS.rough)])
    .then(([color, normal, rough]) => {
      const maxAniso = renderer.capabilities.getMaxAnisotropy();
      [color, normal, rough].forEach(t => {
        t.wrapS = t.wrapT = THREE.RepeatWrapping;
        t.anisotropy = maxAniso;
      });
      color.colorSpace = THREE.SRGBColorSpace;
      const repeat = 4 / WOOD_STRIP_INCHES;   // geometry U counts in 4 in blocks
      color.repeat.set(repeat, 1);
      normal.repeat.set(repeat, 1);
      rough.repeat.set(repeat, 1);
      woodMaps = { color, normal, rough };
      buildScene();                            // repaint with the real wood
    })
    .catch(() => { /* missing asset: the procedural texture stays */ });
}

function l01NaturalOakTexture(){
  const c=document.createElement('canvas');
  c.width=768; c.height=384;
  const g=c.getContext('2d');
  let seed=1012026;
  const rnd=()=>((seed=(seed*1664525+1013904223)>>>0)/4294967296);
  const base=g.createLinearGradient(0,0,0,c.height);
  [[0,'#f0d1aa'],[.25,'#e6bd91'],[.55,'#f6d8b0'],[.8,'#deb388'],[1,'#efd0a6']]
    .forEach(([at,color])=>base.addColorStop(at,color));
  g.fillStyle=base;g.fillRect(0,0,c.width,c.height);
  for(let i=0;i<1450;i++){
    const x=rnd()*c.width,y=rnd()*c.height;
    const len=18+rnd()*270;
    g.strokeStyle=rnd()<0.72
      ? `rgba(123,70,30,${0.025+rnd()*0.11})`
      : `rgba(255,248,219,${0.06+rnd()*0.18})`;
    g.lineWidth=0.2+rnd()*1.2;
    g.beginPath();g.moveTo(x,y);
    g.bezierCurveTo(x+len*.35,y+rnd()*4-2,x+len*.7,y+rnd()*4-2,x+len,y);
    g.stroke();
  }
  for(let i=0;i<120;i++){
    const x=rnd()*c.width,y=rnd()*c.height;
    g.fillStyle=`rgba(139,82,42,${0.025+rnd()*0.08})`;
    g.fillRect(x,y,0.4+rnd()*1.4,0.3+rnd()*1.2);
  }
  // Natural oak has long open grain, occasional cathedral curves and pores.
  for(let band=0;band<18;band++){
    const y=10+rnd()*(c.height-20);
    const amp=5+rnd()*18;
    const center=90+rnd()*(c.width-180);
    const spread=65+rnd()*155;
    g.strokeStyle=`rgba(112,66,31,${0.10+rnd()*0.10})`;
    g.lineWidth=0.7+rnd()*1.4;
    g.beginPath();
    for(let x=0;x<=c.width;x+=6){
      const curve=amp*Math.exp(-Math.pow((x-center)/spread,2));
      const py=y+curve+Math.sin(x*.022+band)*1.1;
      if(x===0)g.moveTo(x,py);else g.lineTo(x,py);
    }
    g.stroke();
  }
  for(let i=0;i<360;i++){
    const x=rnd()*c.width,y=rnd()*c.height;
    g.fillStyle=`rgba(91,52,25,${0.07+rnd()*0.13})`;
    g.beginPath();
    g.ellipse(x,y,0.25+rnd()*0.75,0.7+rnd()*2.1,rnd()*.35-.175,0,Math.PI*2);
    g.fill();
  }
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const l01OakGrain=l01NaturalOakTexture();

function darkWoodTexture(black=false){
  const c=document.createElement('canvas');
  c.width=768;c.height=384;
  const g=c.getContext('2d');
  let seed=black?404404:303303;
  const rnd=()=>((seed=(seed*1664525+1013904223)>>>0)/4294967296);
  const base=g.createLinearGradient(0,0,0,c.height);
  const stops=black
    ? [[0,'#17191a'],[.24,'#252627'],[.50,'#111314'],[.76,'#2b2b2b'],[1,'#121415']]
    : [[0,'#3f3832'],[.22,'#584b41'],[.48,'#342f2b'],[.75,'#5a4e44'],[1,'#302c29']];
  stops.forEach(([at,color])=>base.addColorStop(at,color));
  g.fillStyle=base;g.fillRect(0,0,c.width,c.height);
  for(let i=0;i<1150;i++){
    const y=rnd()*c.height;
    const amp=.35+rnd()*2.8;
    const cycles=1+Math.floor(rnd()*6);
    const phase=rnd()*Math.PI*2;
    const light=rnd()>.76;
    g.strokeStyle=black
      ? (light?`rgba(142,145,146,${.025+rnd()*.10})`:`rgba(0,0,0,${.08+rnd()*.24})`)
      : (light?`rgba(194,166,136,${.035+rnd()*.12})`:`rgba(18,13,10,${.07+rnd()*.23})`);
    g.lineWidth=.25+rnd()*1.15;
    g.beginPath();g.moveTo(0,y+Math.sin(phase)*amp);
    for(let x=10;x<=c.width;x+=10)
      g.lineTo(x,y+Math.sin(phase+cycles*Math.PI*2*x/c.width)*amp);
    g.stroke();
  }
  for(let i=0;i<190;i++){
    const x=rnd()*c.width,y=rnd()*c.height;
    const length=8+rnd()*80;
    g.strokeStyle=black?'rgba(2,2,2,.28)':'rgba(19,12,8,.24)';
    g.lineWidth=.35+rnd()*1.2;
    g.beginPath();g.moveTo(x,y);
    g.bezierCurveTo(x+length*.35,y+rnd()*5-2.5,x+length*.7,y+rnd()*5-2.5,x+length,y);
    g.stroke();
  }
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const l03CharcoalGrain=darkWoodTexture(false);
const l04BlackGrain=darkWoodTexture(true);

function f36BlackTexture(){
  const c = document.createElement('canvas');
  c.width = 512; c.height = 256;
  const g = c.getContext('2d');
  let seed = 361234;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  g.fillStyle = '#d2d2d2';
  g.fillRect(0, 0, c.width, c.height);
  for (let i = 0; i < 850; i++){
    const x = rnd() * c.width, y = rnd() * c.height;
    const length = 12 + rnd() * 160;
    g.strokeStyle = rnd() < 0.78 ? `rgba(18,18,18,${0.05 + rnd()*0.23})`
                                  : `rgba(255,255,255,${0.04 + rnd()*0.16})`;
    g.lineWidth = 0.2 + rnd() * 0.85;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + length, y + rnd()*2-1);
    g.stroke();
  }
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f36Grain = f36BlackTexture();

/* Brushed-metal streaks for F36's silver parts: long fine lines that only vary the
   roughness/bump, so the metal reads as brushed rather than polished. */
function f36BrushedTexture(){
  const c = document.createElement('canvas');
  c.width = 1024; c.height = 128;
  const g = c.getContext('2d');
  let seed = 90210;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  g.fillStyle = '#ffffff';
  g.fillRect(0, 0, c.width, c.height);
  for (let i = 0; i < 1500; i++){
    const y = rnd() * c.height, x = rnd() * c.width;
    const len = 60 + rnd() * 700;
    const v = rnd() < 0.5 ? 0 : 255;
    g.strokeStyle = `rgba(${v},${v},${v},${0.04 + rnd() * 0.11})`;
    g.lineWidth = 0.4 + rnd() * 1.3;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + len, y + (rnd() - 0.5) * 0.7);
    g.stroke();
  }
  const t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.repeat.set(3, 3);
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f36Brushed = f36BrushedTexture();

function f66RusticTexture(){
  const c = document.createElement('canvas');
  c.width = 1024; c.height = 512;
  const g = c.getContext('2d');
  let seed = 661947;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  g.fillStyle = '#c8bcb2';
  g.fillRect(0, 0, c.width, c.height);
  /* the real finish is brushed ACROSS the moulding: dense thin lines running along
     the profile (texture V), not along the rail */
  for (let i = 0; i < 1600; i++){
    const x = rnd()*c.width, y = rnd()*c.height;
    const len = 40 + rnd()*260;
    g.strokeStyle = rnd() < 0.74 ? `rgba(26,17,14,${0.06+rnd()*0.26})`
                                  : `rgba(238,214,184,${0.04+rnd()*0.16})`;
    g.lineWidth = 0.2 + rnd()*1.0;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + (rnd()-0.5)*1.6, y + len);
    g.stroke();
  }
  for (let i = 0; i < 95; i++){
    const x = rnd()*c.width, y = rnd()*c.height;
    g.strokeStyle = `rgba(24,17,15,${0.07+rnd()*0.19})`;
    g.lineWidth = 0.2 + rnd()*0.8;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x+rnd()*5-2.5, y+5+rnd()*33);
    g.stroke();
  }
  /* wear: long fine scratches in every direction, light where the finish has
     rubbed through and dark where grime has settled in them */
  for (let i = 0; i < 320; i++){
    const x = rnd()*c.width, y = rnd()*c.height;
    const len = 20 + rnd()*220;
    const ang = (rnd() - 0.5) * 1.1;
    const light = rnd() < 0.55;
    g.strokeStyle = light ? `rgba(226,206,180,${0.05+rnd()*0.14})`
                          : `rgba(18,12,10,${0.06+rnd()*0.18})`;
    g.lineWidth = 0.25 + rnd()*0.7;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + Math.cos(ang)*len, y + Math.sin(ang)*len);
    g.stroke();
  }
  /* chipped highlights along the arris */
  for (let i = 0; i < 90; i++){
    const x = rnd()*c.width, y = rnd()*c.height;
    g.fillStyle = `rgba(232,214,190,${0.05+rnd()*0.12})`;
    g.beginPath();
    g.ellipse(x, y, 1.5+rnd()*4, 0.6+rnd()*1.2, rnd()*3.14, 0, 6.29);
    g.fill();
  }
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f66Grain = f66RusticTexture();

function f85BronzeOrnamentTexture(){
  const c = document.createElement('canvas');
  c.width = 1024; c.height = 512;
  const g = c.getContext('2d');
  let seed = 850312;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  const bronze = g.createLinearGradient(0, 0, 0, 512);
  [[0,'#62442e'],[0.12,'#a77d55'],[0.25,'#493324'],[0.40,'#75563d'],
   [0.54,'#3e2a20'],[0.68,'#99734f'],[0.78,'#493226'],[0.90,'#9a7754'],
   [1,'#4a3527']].forEach(([at,color]) => bronze.addColorStop(at,color));
  g.fillStyle = bronze; g.fillRect(0,0,c.width,c.height);
  // Fine longitudinal bronze grain is visible under the raised gilding.
  for (let i=0; i<1250; i++){
    const x=rnd()*1024, y=rnd()*512;
    g.strokeStyle = rnd()<0.57 ? `rgba(29,18,13,${0.04+rnd()*0.19})`
                               : `rgba(255,224,171,${0.04+rnd()*0.16})`;
    g.lineWidth=0.3+rnd()*1.4;
    g.beginPath(); g.moveTo(x,y); g.lineTo(x+24+rnd()*340,y+rnd()*3-1.5); g.stroke();
  }
  const ridge = (y, gold='#e2b978') => {
    g.strokeStyle='#291e1a'; g.lineWidth=12;
    g.beginPath(); g.moveTo(0,y+2); g.lineTo(1024,y+2); g.stroke();
    g.strokeStyle=gold; g.lineWidth=5;
    g.beginPath(); g.moveTo(0,y); g.lineTo(1024,y); g.stroke();
    g.strokeStyle='rgba(255,237,187,.58)'; g.lineWidth=1.5;
    g.beginPath(); g.moveTo(0,y-3); g.lineTo(1024,y-3); g.stroke();
  };
  [14,105,279,403,508].forEach(y=>ridge(y));
  // Inner repeating wave moulding.
  for (let x=-24; x<1050; x+=52){
    g.strokeStyle='#241a17'; g.lineWidth=10;
    g.beginPath(); g.moveTo(x,61); g.bezierCurveTo(x+12,20,x+32,20,x+52,61); g.stroke();
    g.strokeStyle='#e5bd79'; g.lineWidth=5;
    g.beginPath(); g.moveTo(x,59); g.bezierCurveTo(x+12,23,x+32,23,x+52,59); g.stroke();
    g.strokeStyle='#fff0bd'; g.lineWidth=1.4;
    g.beginPath(); g.moveTo(x+5,55); g.bezierCurveTo(x+18,30,x+31,30,x+47,55); g.stroke();
  }
  // Dark recessed core and soft ribs across the broad concave bronze face.
  const cove = g.createLinearGradient(0,110,0,277);
  [[0,'rgba(24,16,14,.32)'],[.25,'rgba(234,186,121,.15)'],
   [.52,'rgba(37,25,19,.47)'],[.78,'rgba(238,185,113,.28)'],
   [1,'rgba(26,18,15,.63)']].forEach(([at,color])=>cove.addColorStop(at,color));
  g.fillStyle=cove; g.fillRect(0,110,1024,167);
  for (let y=121; y<269; y+=13){
    g.strokeStyle=y%2?'rgba(241,200,144,.07)':'rgba(26,18,14,.10)';
    g.lineWidth=2; g.beginPath(); g.moveTo(0,y); g.lineTo(1024,y); g.stroke();
  }
  // The middle acanthus scrolls: a dark cut line, antique gold shoulder,
  // and a thin bright crest make each curl legible at detail zoom.
  for (let x=-190; x<1200; x+=390){
    for (const [line,color] of [[16,'#201914'],[10,'#d5a861'],[3,'#f5dfac']]){
      g.strokeStyle=color; g.lineWidth=line; g.lineCap='round'; g.lineJoin='round';
      g.beginPath();
      g.moveTo(x+12,350);
      g.bezierCurveTo(x+45,307,x+114,308,x+143,345);
      g.bezierCurveTo(x+183,395,x+252,376,x+265,336);
      g.bezierCurveTo(x+278,305,x+341,306,x+363,345);
      g.stroke();
    }
    for (const cx of [x+85,x+305]){
      g.strokeStyle='#2c2018'; g.lineWidth=12;
      g.beginPath(); g.arc(cx,344,20,-.6,Math.PI*1.45); g.stroke();
      g.strokeStyle='#f0c77e'; g.lineWidth=6;
      g.beginPath(); g.arc(cx,343,19,-.6,Math.PI*1.45); g.stroke();
      g.strokeStyle='#fff0bd'; g.lineWidth=2;
      g.beginPath(); g.arc(cx,342,16,-.55,Math.PI*1.2); g.stroke();
    }
    for (const dx of [155,205,255]){
      g.fillStyle='#33241b'; g.beginPath(); g.ellipse(x+dx,360,23,9,-.42,0,Math.PI*2); g.fill();
      g.fillStyle='#d3a461'; g.beginPath(); g.ellipse(x+dx,356,19,5,-.42,0,Math.PI*2); g.fill();
    }
  }
  // The outer narrow band uses closely spaced engraved triangles.
  for (let x=-22; x<1040; x+=92){
    g.strokeStyle='#261b17'; g.lineWidth=11; g.lineJoin='round';
    g.beginPath(); g.moveTo(x,485); g.lineTo(x+44,420); g.lineTo(x+88,485); g.stroke();
    g.strokeStyle='#e4bd7c'; g.lineWidth=5;
    g.beginPath(); g.moveTo(x+4,481); g.lineTo(x+44,428); g.lineTo(x+84,481); g.stroke();
    g.strokeStyle='#f8e2ad'; g.lineWidth=1.5;
    g.beginPath(); g.moveTo(x+15,476); g.lineTo(x+44,436); g.lineTo(x+73,476); g.stroke();
    g.strokeStyle='#2c201a'; g.lineWidth=3;
    for(let i=0;i<3;i++){
      g.beginPath(); g.moveTo(x+28+i*8,463-i*9); g.lineTo(x+59-i*8,463-i*9); g.stroke();
    }
  }
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f85Ornament = f85BronzeOrnamentTexture();

function f98GoldOrnamentTexture(){
  const c=document.createElement('canvas');
  c.width=1024; c.height=512;
  const g=c.getContext('2d');
  let seed=981406;
  const rnd=()=>((seed=(seed*1664525+1013904223)>>>0)/4294967296);
  // UVs run from the inner edge at the top of the canvas to the outer edge below.
  const gold=g.createLinearGradient(0,0,0,512);
  [[0,'#996512'],[.08,'#f9de78'],[.18,'#ad741d'],[.27,'#ffe99a'],
   [.43,'#e5b94e'],[.58,'#a9721f'],[.68,'#f9db70'],
   [.81,'#a46e1c'],[.91,'#f5d875'],[1,'#b27d27']]
    .forEach(([at,color])=>gold.addColorStop(at,color));
  g.fillStyle=gold; g.fillRect(0,0,1024,512);

  // Brushed gilding stays visible across the plain central scoop.
  for(let i=0;i<1850;i++){
    const x=rnd()*1024,y=rnd()*512;
    g.strokeStyle=rnd()<0.56 ? `rgba(95,53,8,${0.025+rnd()*0.15})`
                             : `rgba(255,246,181,${0.035+rnd()*0.18})`;
    g.lineWidth=0.35+rnd()*1.1;
    g.beginPath();g.moveTo(x,y);g.lineTo(x+20+rnd()*280,y+rnd()*3-1.5);g.stroke();
  }
  const ridge=(y,width=4)=>{
    g.strokeStyle='rgba(99,53,7,.65)';g.lineWidth=width+5;
    g.beginPath();g.moveTo(0,y+3);g.lineTo(1024,y+3);g.stroke();
    g.strokeStyle='#ffe48a';g.lineWidth=width;
    g.beginPath();g.moveTo(0,y);g.lineTo(1024,y);g.stroke();
    g.strokeStyle='rgba(255,250,197,.8)';g.lineWidth=1.4;
    g.beginPath();g.moveTo(0,y-3);g.lineTo(1024,y-3);g.stroke();
  };
  [8,99,119,301,318,444,482].forEach((y,i)=>ridge(y,i===2||i===4?3:5));

  // Tight S-shaped gilded bead immediately beside the artwork.
  for(let x=-28;x<1055;x+=55){
    for(const [width,color,dy] of [[10,'#84500d',3],[6,'#eabf4b',0],[2,'#fff2ae',-3]]){
      g.strokeStyle=color;g.lineWidth=width;g.lineCap='round';
      g.beginPath();g.moveTo(x,75+dy);
      g.bezierCurveTo(x+12,18+dy,x+26,18+dy,x+29,57+dy);
      g.bezierCurveTo(x+32,83+dy,x+42,84+dy,x+55,44+dy);g.stroke();
    }
  }

  // Shallow concave gold face with a soft bright centre and dark shoulders.
  const scoop=g.createLinearGradient(0,120,0,301);
  [[0,'rgba(92,49,7,.43)'],[.20,'rgba(255,239,142,.20)'],
   [.48,'rgba(255,250,188,.35)'],[.79,'rgba(255,223,105,.12)'],
   [1,'rgba(96,52,7,.46)']]
    .forEach(([at,color])=>scoop.addColorStop(at,color));
  g.fillStyle=scoop;g.fillRect(0,120,1024,181);
  for(let y=132;y<295;y+=8){
    g.strokeStyle=y%3 ? 'rgba(121,71,14,.055)' : 'rgba(255,246,179,.11)';
    g.lineWidth=1;g.beginPath();g.moveTo(0,y);g.lineTo(1024,y);g.stroke();
  }

  // Repeated raised acanthus cups on the outer floral band.
  for(let x=-205;x<1230;x+=205){
    for(const [width,color,dy] of [[25,'#89540d',6],[17,'#d69c25',1],
                                    [9,'#ffe48a',-4],[3,'#fff6b7',-8]]){
      g.strokeStyle=color;g.lineWidth=width;g.lineCap='round';
      g.beginPath();g.moveTo(x+12,333+dy);
      g.bezierCurveTo(x+32,446+dy,x+171,445+dy,x+193,333+dy);g.stroke();
    }
    const cup=g.createLinearGradient(0,342,0,426);
    cup.addColorStop(0,'#fff1a0');cup.addColorStop(.38,'#e9b638');
    cup.addColorStop(.77,'#ab7015');cup.addColorStop(1,'#f9db70');
    g.fillStyle=cup;
    g.beginPath();g.moveTo(x+55,353);
    g.bezierCurveTo(x+75,331,x+127,331,x+149,353);
    g.bezierCurveTo(x+146,389,x+126,410,x+102,412);
    g.bezierCurveTo(x+77,409,x+58,385,x+55,353);g.fill();
    g.strokeStyle='#8e5a10';g.lineWidth=5;
    g.beginPath();g.arc(x+102,359,39,.12,Math.PI-.12);g.stroke();
    g.strokeStyle='#fff4a9';g.lineWidth=4;
    g.beginPath();g.arc(x+102,356,37,.15,Math.PI-.15);g.stroke();
    g.fillStyle='#ad7518';g.beginPath();g.ellipse(x+103,376,19,7,0,0,Math.PI*2);g.fill();
    g.fillStyle='#fff09a';g.beginPath();g.ellipse(x+101,371,17,5,0,0,Math.PI*2);g.fill();
  }
  // A clean outer bevel frames the ornate band.
  const bevel=g.createLinearGradient(0,450,0,512);
  [[0,'rgba(102,59,9,.48)'],[.35,'rgba(255,240,155,.35)'],
   [.72,'rgba(255,232,125,.20)'],[1,'rgba(92,53,7,.30)']]
    .forEach(([at,color])=>bevel.addColorStop(at,color));
  g.fillStyle=bevel;g.fillRect(0,450,1024,62);

  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f98Ornament=f98GoldOrnamentTexture();
function f98SilverOrnamentTexture(){
  const source=f98Ornament.image;
  const c=document.createElement('canvas');
  c.width=source.width; c.height=source.height;
  const g=c.getContext('2d');
  g.drawImage(source,0,0);
  const pixels=g.getImageData(0,0,c.width,c.height);
  for(let i=0;i<pixels.data.length;i+=4){
    const r=pixels.data[i],green=pixels.data[i+1],b=pixels.data[i+2];
    const luminance=0.2126*r+0.7152*green+0.0722*b;
    const silver=Math.max(48,Math.min(250,1.10*luminance+10));
    pixels.data[i]=silver;
    pixels.data[i+1]=Math.min(255,silver+2);
    pixels.data[i+2]=Math.min(255,silver+6);
  }
  g.putImageData(pixels,0,0);
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f98SilverOrnament=f98SilverOrnamentTexture();

function f91AntiqueGoldTexture(){
  const c = document.createElement('canvas');
  c.width = 1024; c.height = 512;
  const g = c.getContext('2d');
  let seed = 910217;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  // The canvas bands follow the frame profile from its inner edge at the
  // image top to its outer edge at the image bottom.
  const base = g.createLinearGradient(0,0,0,512);
  [[0,'#977443'],[.12,'#e4c58e'],[.20,'#8e6a3d'],[.31,'#f3dba7'],
   [.48,'#e7c894'],[.59,'#745537'],[.63,'#2a211b'],[.85,'#211c18'],
   [.89,'#987142'],[.97,'#e4c78f'],[1,'#87633d']]
    .forEach(([at,color])=>base.addColorStop(at,color));
  g.fillStyle=base; g.fillRect(0,0,1024,512);

  // Small irregular dark pores and rubbed gold show through the broad cove.
  for(let i=0;i<3100;i++){
    const x=rnd()*1024, y=rnd()*512;
    if(y>319 && y<444) continue;
    g.fillStyle=rnd()<0.77 ? `rgba(56,37,24,${0.12+rnd()*0.38})`
                            : `rgba(255,246,208,${0.10+rnd()*0.35})`;
    const s=0.35+rnd()*1.5;
    g.fillRect(x,y,s,s*(0.6+rnd()*1.8));
  }
  for(let i=0;i<210;i++){
    const x=rnd()*1024, y=rnd()*512;
    if(y>320 && y<444) continue;
    g.strokeStyle=rnd()<0.5?'rgba(88,57,32,.09)':'rgba(255,243,202,.18)';
    g.lineWidth=0.4+rnd()*1.1;
    g.beginPath(); g.moveTo(x,y); g.lineTo(x+22+rnd()*230,y+rnd()*2-1); g.stroke();
  }
  // Gold cove has a darker recessed shoulder and a long soft crest.
  const cove=g.createLinearGradient(0,76,0,316);
  [[0,'rgba(50,32,21,.41)'],[.22,'rgba(255,244,203,.22)'],
   [.48,'rgba(255,249,222,.43)'],[.72,'rgba(131,86,43,.19)'],
   [1,'rgba(54,36,23,.50)']].forEach(([at,color])=>cove.addColorStop(at,color));
  g.fillStyle=cove; g.fillRect(0,76,1024,240);

  const ridge=(y,w=5)=>{
    g.strokeStyle='#3a291c'; g.lineWidth=w+6;
    g.beginPath(); g.moveTo(0,y+2); g.lineTo(1024,y+2); g.stroke();
    g.strokeStyle='#efd29b'; g.lineWidth=w;
    g.beginPath(); g.moveTo(0,y); g.lineTo(1024,y); g.stroke();
    g.strokeStyle='rgba(255,250,222,.68)'; g.lineWidth=1.4;
    g.beginPath(); g.moveTo(0,y-3); g.lineTo(1024,y-3); g.stroke();
  };
  [11,69,313,443,505].forEach(y=>ridge(y,y===313||y===443?5:3));

  // Repeating black-ground acanthus leaves, with gold raised surfaces.
  const leaf=(x,y,angle,size)=>{
    g.save(); g.translate(x,y); g.rotate(angle); g.scale(size,size);
    g.fillStyle='#171512'; g.strokeStyle='#100e0d'; g.lineWidth=8;
    g.beginPath();
    g.moveTo(0,0); g.bezierCurveTo(18,-11,23,-31,41,-38);
    g.bezierCurveTo(38,-20,59,-31,73,-34);
    g.bezierCurveTo(59,-17,62,-8,79,-5);
    g.bezierCurveTo(39,1,27,22,0,0); g.closePath(); g.stroke();
    g.fillStyle='#dbb57b'; g.fill();
    g.strokeStyle='#fff0c5'; g.lineWidth=3;
    g.beginPath(); g.moveTo(6,-1); g.bezierCurveTo(35,-4,47,-21,70,-27); g.stroke();
    g.strokeStyle='#6c4b2d'; g.lineWidth=2;
    g.beginPath(); g.moveTo(25,-5); g.lineTo(40,-23); g.moveTo(44,-9); g.lineTo(60,-18); g.stroke();
    g.restore();
  };
  for(let x=-490;x<1150;x+=510){
    for(const [line,color] of [[22,'#100f0d'],[13,'#bd9966'],[4,'#f7e2ad']]){
      g.strokeStyle=color; g.lineWidth=line; g.lineCap='round';
      g.beginPath(); g.moveTo(x+4,392);
      g.bezierCurveTo(x+110,417,x+168,358,x+246,375);
      g.bezierCurveTo(x+352,401,x+425,348,x+514,389); g.stroke();
    }
    [[66,391,-.37,.92],[229,375,-.08,1.06],[397,375,.33,.94]]
      .forEach(([dx,y,a,s])=>leaf(x+dx,y,a,s));
    for(const [cx,cy,flip] of [[x+149,370,1],[x+350,389,-1]]){
      g.save(); g.translate(cx,cy); g.scale(flip,1);
      for(const [line,color] of [[23,'#15120f'],[13,'#e0b978'],[4,'#fff0c8']]){
        g.strokeStyle=color; g.lineWidth=line;
        g.beginPath(); g.arc(0,0,27,-2.6,2.15); g.stroke();
      }
      g.restore();
    }
    g.fillStyle='#f0d198';
    for(const dx of [20,279,491]){
      g.beginPath(); g.arc(x+dx,391,7,0,Math.PI*2); g.fill();
    }
  }

  // A much smaller chiseled pattern runs around the print opening.
  for(let x=-17;x<1045;x+=35){
    g.strokeStyle='#36251b'; g.lineWidth=8; g.lineJoin='round';
    g.beginPath(); g.moveTo(x,55); g.lineTo(x+17,23); g.lineTo(x+34,55); g.stroke();
    g.strokeStyle='#ffe4a9'; g.lineWidth=3;
    g.beginPath(); g.moveTo(x+3,51); g.lineTo(x+17,30); g.lineTo(x+31,51); g.stroke();
    g.strokeStyle='#6d4d2d'; g.lineWidth=2;
    g.beginPath(); g.moveTo(x+10,46); g.lineTo(x+24,46); g.stroke();
  }
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f91Ornament = f91AntiqueGoldTexture();

function f91SideTexture(){
  const c=document.createElement('canvas');
  c.width=512; c.height=128;
  const g=c.getContext('2d');
  let seed=911206;
  const rnd=()=>((seed=(seed*1664525+1013904223)>>>0)/4294967296);
  g.fillStyle='#ded0ae'; g.fillRect(0,0,512,128);
  for(let i=0;i<1900;i++){
    const x=rnd()*512,y=rnd()*128;
    g.fillStyle=rnd()<0.8 ? `rgba(46,31,20,${0.08+rnd()*0.35})`
                            : `rgba(255,245,215,${0.1+rnd()*0.3})`;
    const s=0.25+rnd()*1.3;
    g.fillRect(x,y,s,s*(0.6+rnd()*1.7));
  }
  for(let i=0;i<130;i++){
    const x=rnd()*512,y=rnd()*128;
    g.strokeStyle=rnd()<0.5?'rgba(58,38,24,.07)':'rgba(255,246,214,.13)';
    g.lineWidth=0.3+rnd()*0.8;
    g.beginPath();g.moveTo(x,y);g.lineTo(x+15+rnd()*150,y+rnd()*2-1);g.stroke();
  }
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f91SideGrain=f91SideTexture();

function f92BronzeWoodTexture(){
  const c=document.createElement('canvas');
  c.width=512; c.height=256;
  const g=c.getContext('2d');
  let seed=922418;
  const rnd=()=>((seed=(seed*1664525+1013904223)>>>0)/4294967296);
  g.fillStyle='#d8d0c1';g.fillRect(0,0,512,256);
  // Continuous horizontal grain: both ends meet at the same height, so
  // repeated UVs cannot leave diagonal seams across a moulding rail.
  for(let i=0;i<680;i++){
    const y=rnd()*256,amp=0.15+rnd()*1.15;
    const cycles=1+Math.floor(rnd()*5),phase=rnd()*Math.PI*2;
    g.strokeStyle=rnd()<0.72 ? `rgba(29,25,21,${0.045+rnd()*0.21})`
                            : `rgba(255,236,196,${0.025+rnd()*0.11})`;
    g.lineWidth=0.2+rnd()*0.9;
    g.beginPath();g.moveTo(0,y+amp*Math.sin(phase));
    for(let x=8;x<=512;x+=8)
      g.lineTo(x,y+amp*Math.sin(phase+cycles*Math.PI*2*x/512));
    g.stroke();
  }
  for(let i=0;i<120;i++){
    const x=rnd()*512,y=rnd()*256,len=12+rnd()*130,dy=rnd()*1.2-0.6;
    g.strokeStyle=rnd()<0.7?'rgba(27,24,21,.10)':'rgba(255,242,211,.10)';
    g.lineWidth=0.25+rnd()*0.6;
    for(const shift of [-512,0,512]){
      g.beginPath();g.moveTo(x+shift,y);
      g.lineTo(x+shift+len,y+dy);g.stroke();
    }
  }
  const t=new THREE.CanvasTexture(c);
  t.colorSpace=THREE.SRGBColorSpace;
  t.wrapS=t.wrapT=THREE.RepeatWrapping;
  t.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return t;
}
const f92Grain=f92BronzeWoodTexture();

function mouldingProfileGeometry(W, H, profile, outward = false, seam = 0, seamW = 0.05, seamShade = 0.25){
  const positions = [], colors = [], uvs = [], indices = [];
  const rMax = profile[profile.length - 1].r;
  /* Each rail is swept from one mitre to the next. With `seam`, extra columns are
     added just inside each corner and only the corner columns drop in z, which
     cuts a groove down the 45° joint instead of blending the two faces into one
     inflated blob. */
  const sidePoint = (side, r, t) => {
    const L = (side % 2 ? H : W) - 2 * r;
    if (side === 0) return [-W/2 + r + t*L,  H/2 - r];
    if (side === 1) return [ W/2 - r,         H/2 - r - t*L];
    if (side === 2) return [ W/2 - r - t*L,  -H/2 + r];
    return              [-W/2 + r,           -H/2 + r + t*L];
  };
  for (let side = 0; side < 4; side++){
    const start = positions.length / 3;
    profile.forEach(p => {
      const color = new THREE.Color(p.c);
      const L = (side % 2 ? H : W) - 2 * p.r;
      const sw = seam ? Math.min(seamW, L / 4) / L : 0;     // seam width as a fraction
      const ts = seam ? [0, sw, 1 - sw, 1] : [0, 1];
      for (const t of ts){
        const [x, y] = sidePoint(side, p.r, t);
        const atSeam = !!seam && (t === 0 || t === 1);
        positions.push(x, y, p.z - (atSeam ? seam : 0));
        /* the joint is a crack in the finish, not a lit ridge: darken the seam
           columns so the corner reads as a cut whatever the key light does */
        const shade = atSeam ? seamShade : 1;
        colors.push(color.r * shade, color.g * shade, color.b * shade);
        uvs.push(t * L / 4, outward ? p.z / 1.04 : p.r / rMax);
      }
    });
    const C = seam ? 4 : 2;
    for (let j = 0; j < profile.length - 1; j++){
      for (let k = 0; k < C - 1; k++){
        const a = start + j*C + k, b = a + 1;
        const c = start + (j+1)*C + k, d = c + 1;
        if (outward) indices.push(a, b, c, b, d, c);
        else indices.push(a, c, b, b, c, d);
      }
    }
  }
  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
  geo.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
  geo.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
  geo.setIndex(indices);
  geo.computeVertexNormals();
  return geo;
}

function f98MitredProfileGeometry(W,H){
  const geo=mouldingProfileGeometry(W,H,F97_SHALLOW_PROFILE);
  const position=geo.getAttribute('position');
  const cornerX=[-1,1,1,-1],cornerY=[1,1,-1,-1];
  for(let side=0;side<4;side++){
    for(let i=0;i<F97_SHALLOW_PROFILE.length;i++){
      const shift=F97_MITER_OFFSETS[i];
      for(let end=0;end<2;end++){
        const corner=(side+end)%4;
        const vertex=side*F97_SHALLOW_PROFILE.length*2+i*2+end;
        position.setXY(vertex,position.getX(vertex)+cornerX[corner]*shift,
                              position.getY(vertex)-cornerY[corner]*shift);
      }
    }
  }
  position.needsUpdate=true;
  geo.computeVertexNormals();
  return geo;
}

function f98ThickStraightSideGeometry(W,H,silver=false){
  const weights=[0,0,0,0,0.12,0.32,0.75,1];
  const profile=F97_SIDE_PROFILE.map((p,i)=>({
    ...p,r:p.r-0.14*weights[i],c:silver?L01_SILVER_SIDE_COLORS[i]:p.c
  }));
  profile.push({r:-0.28,z:F97_BACK_Z,c:silver?0x747b84:0x865b19});
  return mouldingProfileGeometry(W,H,profile,true);
}

function buildF35(W, H){
  const backing = new THREE.Mesh(
    ringGeometry(W, H, W-2.8, H-2.8, 0.70, 0.012),
    new THREE.MeshStandardMaterial({color:0x281710, roughness:0.67})
  );
  backing.castShadow = true;
  hang.add(backing);

  const walnutMat = new THREE.MeshStandardMaterial({map:f35Grain, vertexColors:true,
    bumpMap:f35Grain, bumpScale:0.018,
    roughness:0.53, metalness:0, side:THREE.DoubleSide, envMapIntensity:0.65});
  if (woodMaps){
    /* the crop is a narrow face band, so using it as the albedo smears badly when
       it is stretched over the whole profile. Use it for what it is good at —
       pore-level relief and the satin sheen — and keep the procedural wood for
       colour, which tiles cleanly. */
    walnutMat.normalMap = woodMaps.normal;
    walnutMat.normalScale.set(0.45, 0.45);
    walnutMat.roughnessMap = woodMaps.rough;
    /* the reference has a satin sheen running along the moulding, so let the
       material keep some gloss on top of the map */
    walnutMat.roughness = 0.72;
    walnutMat.bumpMap = null;
    walnutMat.envMapIntensity = 0.95;
  } else {
    ensureWoodMaps();
  }
  const walnut = new THREE.Mesh(mouldingProfileGeometry(W, H, F35_PROFILE, false, SEAM.depth, SEAM.width, SEAM.shade), walnutMat);
  walnut.castShadow = true;
  walnut.receiveShadow = true;
  hang.add(walnut);

  /* Recessed bead channel between the moulding and the inner lip: the wood stops
     at r=1.16, this dark ring runs 1.16-1.36, and a thin wood lip closes it off
     against the art. The beads sit inside the recess. */
  const channel = new THREE.Mesh(
    ringGeometry(W-2.32, H-2.32, W-2.72, H-2.72, 0.70, 0),
    new THREE.MeshStandardMaterial({color:0x17130f, roughness:0.86})
  );
  channel.receiveShadow = true;
  hang.add(channel);

  const innerLip = new THREE.Mesh(
    ringGeometry(W-2.72, H-2.72, W-2.80, H-2.80, 0.745, 0.006),
    new THREE.MeshStandardMaterial({color:0x57473c, roughness:0.55})
  );
  hang.add(innerLip);

  const beadInset = 1.26;
  const halfW = W / 2 - beadInset;
  const halfH = H / 2 - beadInset;
  const perim = 4 * (halfW + halfH);
  const pitch = 0.125;
  const count = Math.max(8, Math.round(perim / pitch));
  const step = perim / count;
  const beadSpot = s => {
    const top = 2 * halfW, side = 2 * halfH;
    let t = ((s % perim) + perim) % perim;
    if (t < top) return { x: -halfW + t, y: halfH, nx: 0, ny: 1 };
    t -= top;
    if (t < side) return { x: halfW, y: halfH - t, nx: 1, ny: 0 };
    t -= side;
    if (t < top) return { x: halfW - t, y: -halfH, nx: 0, ny: -1 };
    t -= top;
    return { x: -halfW, y: -halfH + t, nx: -1, ny: 0 };
  };

  /* the reference beads read as small cut stones, not pearls: a six-sided prism
     with flat facets, its axis pointing at the viewer */
  const studs = new THREE.InstancedMesh(
    new THREE.CylinderGeometry(0.62, 1, 1, 6),
    /* one gold for the whole row — the per-bead tint variation read as noise */
    new THREE.MeshStandardMaterial({ color:0xc19247, metalness:0.78, roughness:0.38,
      flatShading:true, envMapIntensity:1.15 }), count
  );
  const dummy = new THREE.Object3D();
  for (let i = 0; i < count; i++){
    const spot = beadSpot((i + 0.5) * step);
    /* sunk into the recess: the top stays below the inner lip (0.745) */
    dummy.position.set(spot.x, spot.y, 0.712);
    /* axis along z (facing the viewer), hexagon spun a little per bead */
    dummy.rotation.set(Math.PI / 2, 0, 0);
    dummy.rotation.z = ((i * 53) % 6) * Math.PI / 18;
    const wobble = 1 + ((i * 37) % 7 - 3) * 0.008;
    /* local x across the moulding, local y along the row, local z toward the
       viewer; shallow enough that the stone sits inside the channel */
    dummy.scale.set(0.052 * wobble, 0.026, 0.046 * wobble);
    dummy.updateMatrix();
    studs.setMatrixAt(i, dummy.matrix);
  }
  studs.instanceMatrix.needsUpdate = true;
  studs.castShadow = true;
  hang.add(studs);
}

function buildF36(W, H){
  const backing = new THREE.Mesh(
    ringGeometry(W, H, W-2.3, H-2.3, 0.76, 0.01),
    new THREE.MeshStandardMaterial({color:0x121315, roughness:0.72})
  );
  backing.castShadow = true;
  hang.add(backing);

  const blackWood = new THREE.Mesh(mouldingProfileGeometry(W, H, F36_PROFILE),
    new THREE.MeshStandardMaterial({map:f36Grain, vertexColors:true,
      bumpMap:f36Grain, bumpScale:0.012, roughness:0.72,
      metalness:0, side:THREE.DoubleSide, envMapIntensity:0.5}));
  blackWood.castShadow = true;
  blackWood.receiveShadow = true;
  hang.add(blackWood);

  /* Brushed-metal border around the whole outside — side walls plus a narrow band
     across the front face. */
  const outerSide = new THREE.Mesh(
    ringGeometry(W+0.03, H+0.03, W-0.10, H-0.10, 1.002, 0.004),
    [new THREE.MeshStandardMaterial({color:0xc9cdd0, roughness:0.65,
      metalness:0.88, envMapIntensity:1.35,
      roughnessMap:f36Brushed, bumpMap:f36Brushed, bumpScale:0.0035}),
     new THREE.MeshStandardMaterial({color:0xb9bec1, roughness:0.70,
      metalness:0.86, envMapIntensity:1.30,
      roughnessMap:f36Brushed, bumpMap:f36Brushed, bumpScale:0.0035})]
  );
  outerSide.castShadow = true;
  hang.add(outerSide);

  /* Dark shadow line where the metal band meets the black face. */
  /* the recessed metal liner sits below the black face, so this ring is the step
     wall / shadow between the two */
  const shadowGap = new THREE.Mesh(
    ringGeometry(W-1.80, H-1.80, W-1.96, H-1.96, 0.995, 0.004),
    new THREE.MeshStandardMaterial({color:0x0b0c0e, roughness:0.92})
  );
  hang.add(shadowGap);

  /* Inner liner in the same brushed metal as the outside. */
  const whiteLiner = new THREE.Mesh(
    ringGeometry(W-1.96, H-1.96, W-2.30, H-2.30, 0.855, 0.010),
    new THREE.MeshStandardMaterial({color:0xc9cdd0, roughness:0.68,
      metalness:0.88, envMapIntensity:1.30,
      roughnessMap:f36Brushed, bumpMap:f36Brushed, bumpScale:0.0035})
  );
  whiteLiner.castShadow = true;
  whiteLiner.receiveShadow = true;
  hang.add(whiteLiner);
}

function buildF66(W, H){
  const backing = new THREE.Mesh(
    ringGeometry(W-0.5, H-0.5, W-2.5, H-2.5, 0.73, 0.005),
    new THREE.MeshStandardMaterial({color:0x211a17, roughness:0.76})
  );
  backing.castShadow = true;
  hang.add(backing);
  const rearCap = new THREE.Mesh(
    ringGeometry(W-0.05, H-0.05, W-2.5, H-2.5, 0.020, 0),
    new THREE.MeshStandardMaterial({color:0x241d19, roughness:0.79})
  );
  rearCap.position.z = 0.0;
  hang.add(rearCap);

  const espresso = new THREE.Mesh(mouldingProfileGeometry(W, H, F66_PROFILE),
    new THREE.MeshStandardMaterial({map:f66Grain, vertexColors:true,
      bumpMap:f66Grain, bumpScale:0.05, roughness:0.62,
      metalness:0, side:THREE.DoubleSide, envMapIntensity:0.55}));
  espresso.castShadow = true;
  espresso.receiveShadow = true;
  hang.add(espresso);

  const sideCove = new THREE.Mesh(mouldingProfileGeometry(W, H, F66_SIDE_PROFILE, true),
    new THREE.MeshStandardMaterial({map:f66Grain, vertexColors:true,
      bumpMap:f66Grain, bumpScale:0.045, roughness:0.66,
      metalness:0, side:THREE.DoubleSide, envMapIntensity:0.5}));
  sideCove.castShadow = true;
  sideCove.receiveShadow = true;
  hang.add(sideCove);

  const inset = new THREE.Mesh(
    ringGeometry(W-2.40, H-2.40, W-2.5, H-2.5, 0.89, 0),
    new THREE.MeshStandardMaterial({color:0x211d1a, roughness:0.79})
  );
  inset.receiveShadow = true;
  hang.add(inset);
  const innerEdge = new THREE.Mesh(
    ringGeometry(W-2.42, H-2.42, W-2.5, H-2.5, 0.905, 0.004),
    new THREE.MeshStandardMaterial({color:0x322a24, roughness:0.65})
  );
  hang.add(innerEdge);

  /* Tarnished, irregular gold marks rather than the raised F35 bead row. */
  let seed = 668881;
  const rnd = () => ((seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296);
  const flecks = [], fleckInset = 1.12;
  const addLine = (length, place, vertical) => {
    const count = Math.max(1, Math.floor(length / 0.10));
    for (let i = 0; i < count; i++){
      if (rnd() < 0.05) continue;
      const xy = place((i + 0.5) / count);
      xy[vertical ? 0 : 1] += (rnd() - 0.5) * 0.035;
      flecks.push({xy, vertical});
    }
  };
  addLine(W-2*fleckInset, t => [-W/2+fleckInset+t*(W-2*fleckInset), H/2-fleckInset], false);
  addLine(W-2*fleckInset, t => [-W/2+fleckInset+t*(W-2*fleckInset), -H/2+fleckInset], false);
  addLine(H-2*fleckInset, t => [-W/2+fleckInset, -H/2+fleckInset+t*(H-2*fleckInset)], true);
  addLine(H-2*fleckInset, t => [W/2-fleckInset, -H/2+fleckInset+t*(H-2*fleckInset)], true);
  const spots = new THREE.InstancedMesh(
    new THREE.IcosahedronGeometry(1, 0),
    new THREE.MeshStandardMaterial({color:0xffffff, metalness:0.61,
      roughness:0.45, flatShading:true, envMapIntensity:1.0}), flecks.length
  );
  const dummy = new THREE.Object3D();
  const patina = [0x9a6f2c, 0xb8862f, 0xc9a04a, 0xd6b264];
  flecks.forEach((fleck, i) => {
    dummy.position.set(fleck.xy[0], fleck.xy[1], 0.862);
    dummy.rotation.z = (fleck.vertical ? Math.PI/2 : 0) + (rnd()-0.5)*0.3;
    dummy.scale.set(0.022+rnd()*0.010, 0.009+rnd()*0.006, 0.008+rnd()*0.005);
    dummy.updateMatrix();
    spots.setMatrixAt(i, dummy.matrix);
    spots.setColorAt(i, new THREE.Color(patina[Math.floor(rnd()*patina.length)]));
  });
  spots.instanceMatrix.needsUpdate = true;
  if (spots.instanceColor) spots.instanceColor.needsUpdate = true;
  hang.add(spots);
}

function buildF84(W, H){
  const backing = new THREE.Mesh(
    ringGeometry(W, H, W-2.4, H-2.4, 0.76, 0.006),
    new THREE.MeshStandardMaterial({color:0x34251c, roughness:0.66, metalness:0.10})
  );
  backing.castShadow = true;
  hang.add(backing);

  const bronze = new THREE.Mesh(mouldingProfileGeometry(W, H, F84_PROFILE),
    new THREE.MeshStandardMaterial({map:f85Ornament, bumpMap:f85Ornament,
      bumpScale:0.028, roughness:0.46, metalness:0.34,
      side:THREE.DoubleSide, envMapIntensity:1.05}));
  bronze.castShadow = true;
  bronze.receiveShadow = true;
  hang.add(bronze);

  const innerLip = new THREE.Mesh(
    ringGeometry(W-2.35, H-2.35, W-2.4, H-2.4, 0.84, 0.003),
    new THREE.MeshStandardMaterial({color:0x37261c, roughness:0.52,
      metalness:0.24, envMapIntensity:0.65})
  );
  innerLip.castShadow = true;
  hang.add(innerLip);
}

function buildL01(W,H){
  const backing=new THREE.Mesh(
    ringGeometry(W,H,W-0.60,H-0.60,0.18,0),
    new THREE.MeshStandardMaterial({map:l01OakGrain,bumpMap:l01OakGrain,
      bumpScale:0.028,roughness:0.70,metalness:0})
  );
  backing.castShadow=true;
  hang.add(backing);

  const oak=new THREE.Mesh(mouldingProfileGeometry(W,H,L01_OAK_PROFILE),
    new THREE.MeshStandardMaterial({map:l01OakGrain,vertexColors:true,
      bumpMap:l01OakGrain,bumpScale:0.045,roughness:0.68,metalness:0,
      flatShading:true,side:THREE.DoubleSide,envMapIntensity:0.62}));
  oak.castShadow=true;
  oak.receiveShadow=true;
  hang.add(oak);

  /* The recessed inner shelf is the short leg of the L-shaped moulding. */
  const innerShelf=new THREE.Mesh(
    ringGeometry(W-0.54,H-0.54,W-1.26,H-1.26,0.255,0),
    new THREE.MeshStandardMaterial({map:l01OakGrain,bumpMap:l01OakGrain,
      bumpScale:0.038,roughness:0.70,metalness:0,
      side:THREE.DoubleSide,envMapIntensity:0.55})
  );
  innerShelf.position.z=1.50;
  innerShelf.castShadow=true;
  innerShelf.receiveShadow=true;
  hang.add(innerShelf);
}

function buildDarkWoodFrame(W,H,texture,black=false){
  const backing=new THREE.Mesh(
    ringGeometry(W,H,W-0.60,H-0.60,0.18,0),
    new THREE.MeshStandardMaterial({map:texture,bumpMap:texture,
      bumpScale:black?0.055:0.065,roughness:black?0.80:0.77,metalness:0})
  );
  backing.castShadow=true;
  hang.add(backing);

  const wood=new THREE.Mesh(mouldingProfileGeometry(W,H,L01_OAK_PROFILE),
    new THREE.MeshStandardMaterial({map:texture,vertexColors:true,
      bumpMap:texture,bumpScale:black?0.070:0.082,
      roughness:black?0.78:0.74,metalness:0,side:THREE.DoubleSide,
      envMapIntensity:black?0.34:0.40}));
  wood.castShadow=true;
  wood.receiveShadow=true;
  hang.add(wood);

  const innerLip=new THREE.Mesh(
    ringGeometry(W-0.54,H-0.54,W-1.26,H-1.26,0.255,0),
    new THREE.MeshStandardMaterial({map:texture,bumpMap:texture,
      bumpScale:black?0.045:0.055,roughness:0.82,metalness:0,
      side:THREE.DoubleSide,envMapIntensity:0.30})
  );
  innerLip.position.z=1.50;
  innerLip.castShadow=true;
  innerLip.receiveShadow=true;
  hang.add(innerLip);
}

function buildF97(W,H,silver=false){
  const rearCap=new THREE.Mesh(
    ringGeometry(W+0.56,H+0.56,W-2.96,H-2.96,F97_BACK_Z,0),
    new THREE.MeshStandardMaterial({color:silver?0xa2a9b1:0x9f7224,roughness:0.51,metalness:0.28})
  );
  hang.add(rearCap);

  const ornament=silver?f98SilverOrnament:f98Ornament;
  const ornateFace=new THREE.Mesh(f98MitredProfileGeometry(W,H),
    new THREE.MeshStandardMaterial({map:ornament,bumpMap:ornament,
      bumpScale:0.025,roughness:0.49,metalness:0.30,
      side:THREE.DoubleSide,envMapIntensity:0.86}));
  ornateFace.castShadow=true;
  ornateFace.receiveShadow=true;
  hang.add(ornateFace);

  const outerSide=new THREE.Mesh(f98ThickStraightSideGeometry(W,H,silver),
    new THREE.MeshStandardMaterial({vertexColors:true,roughness:0.43,metalness:0.39,
      side:THREE.DoubleSide,envMapIntensity:0.92}));
  outerSide.castShadow=true;
  outerSide.receiveShadow=true;
  hang.add(outerSide);

  const innerLip=new THREE.Mesh(
    ringGeometry(W-2.91,H-2.91,W-2.96,H-2.96,0.84*F97_DEPTH_SCALE,0.003),
    new THREE.MeshStandardMaterial({color:silver?0xe5eaee:0xe6b93f,roughness:0.34,
      metalness:0.53,envMapIntensity:1.0})
  );
  innerLip.castShadow=true;
  hang.add(innerLip);
}

function buildF85(W, H){
  const backing = new THREE.Mesh(
    ringGeometry(W-0.10, H-0.10, W-2.48, H-2.48, 0.75, 0.006),
    new THREE.MeshStandardMaterial({color:0x45311f, roughness:0.63, metalness:0.15})
  );
  backing.castShadow=true;
  hang.add(backing);
  const rearCap=new THREE.Mesh(
    ringGeometry(W+0.46,H+0.46,W-2.48,H-2.48,0.025,0),
    new THREE.MeshStandardMaterial({color:0x5b4330,roughness:0.72,metalness:0.12})
  );
  rearCap.position.z=-0.025;
  hang.add(rearCap);

  const ornate = new THREE.Mesh(mouldingProfileGeometry(W,H,F85_PROFILE),
    new THREE.MeshStandardMaterial({map:f91Ornament, bumpMap:f91Ornament,
      bumpScale:0.035, roughness:0.43, metalness:0.36,
      side:THREE.DoubleSide, envMapIntensity:1.02}));
  ornate.castShadow=true;
  ornate.receiveShadow=true;
  hang.add(ornate);

  const slopedSide=new THREE.Mesh(mouldingProfileGeometry(W,H,F85_SIDE_PROFILE,true),
    new THREE.MeshStandardMaterial({map:f91SideGrain,vertexColors:true,
      bumpMap:f91SideGrain,bumpScale:0.018,roughness:0.52,metalness:0.25,
      side:THREE.DoubleSide,envMapIntensity:0.78}));
  slopedSide.castShadow=true;
  slopedSide.receiveShadow=true;
  hang.add(slopedSide);

  const innerLip = new THREE.Mesh(
    ringGeometry(W-2.44,H-2.44,W-2.48,H-2.48,0.86,0.003),
    new THREE.MeshStandardMaterial({color:0x694624,roughness:0.49,
      metalness:0.32,envMapIntensity:0.8})
  );
  innerLip.castShadow=true;
  hang.add(innerLip);
}

function buildF91(W,H){
  const backing=new THREE.Mesh(
    ringGeometry(W,H,W-2.70,H-2.70,0.68*F91_DEPTH_SCALE,0.006),
    [new THREE.MeshStandardMaterial({color:0x372e26,roughness:0.68}),
     new THREE.MeshStandardMaterial({color:0x54483b,map:f92Grain,
       bumpMap:f92Grain,bumpScale:0.012,roughness:0.66,metalness:0.08})]
  );
  backing.castShadow=true;
  hang.add(backing);

  const moulding=new THREE.Mesh(mouldingProfileGeometry(W,H,F91_SHALLOW_PROFILE),
    new THREE.MeshStandardMaterial({map:f92Grain,vertexColors:true,
      bumpMap:f92Grain,bumpScale:0.022,roughness:0.59,metalness:0.12,
      side:THREE.DoubleSide,envMapIntensity:0.66}));
  moulding.castShadow=true;
  moulding.receiveShadow=true;
  hang.add(moulding);
}

function buildF92(W,H){
  const backing=new THREE.Mesh(
    ringGeometry(W,H,W-2.70,H-2.70,0.68*F91_DEPTH_SCALE,0.006),
    [new THREE.MeshStandardMaterial({color:0xf0f1f0,roughness:0.74}),
     new THREE.MeshStandardMaterial({color:0xe7e9e9,roughness:0.77})]
  );
  backing.castShadow=true;
  hang.add(backing);

  const whiteMoulding=new THREE.Mesh(mouldingProfileGeometry(W,H,F92_WHITE_PROFILE),
    new THREE.MeshStandardMaterial({vertexColors:true,roughness:0.68,
      metalness:0,side:THREE.DoubleSide,envMapIntensity:0.55}));
  whiteMoulding.castShadow=true;
  whiteMoulding.receiveShadow=true;
  hang.add(whiteMoulding);
}

function buildF93(W,H,profile=F93_BLACK_GOLD_PROFILE){
  const backing=new THREE.Mesh(
    ringGeometry(W,H,W-2.70,H-2.70,0.68*F91_DEPTH_SCALE,0.006),
    [new THREE.MeshStandardMaterial({color:0x16181b,roughness:0.68}),
     new THREE.MeshStandardMaterial({color:0x22252a,roughness:0.62})]
  );
  backing.castShadow=true;
  hang.add(backing);

  const accentMoulding=new THREE.Mesh(mouldingProfileGeometry(W,H,profile),
    new THREE.MeshStandardMaterial({vertexColors:true,roughness:0.46,
      metalness:0.16,side:THREE.DoubleSide,envMapIntensity:0.72}));
  accentMoulding.castShadow=true;
  accentMoulding.receiveShadow=true;
  hang.add(accentMoulding);
}

/* ============================================================
   Artwork — built-in samples generated on canvas
   ============================================================ */
function makeRng(seed){
  let s = seed >>> 0;
  return () => ((s = (s * 1664525 + 1013904223) >>> 0) / 4294967296);
}
function paperGrain(g, W, H, amount = 0.05, seed = 9){
  const r = makeRng(seed);
  g.save();
  g.globalAlpha = amount;
  for (let i = 0; i < Math.round(W * H / 900); i++){
    g.fillStyle = r() > 0.5 ? '#ffffff' : '#000000';
    g.fillRect(r() * W, r() * H, 1.4, 1.4);
  }
  g.restore();
}

const ART = {
  sunrise(g, W, H){
    const sky = g.createLinearGradient(0, 0, 0, H * 0.74);
    sky.addColorStop(0,   '#25335e');
    sky.addColorStop(0.34,'#7b6d8f');
    sky.addColorStop(0.58,'#e59a63');
    sky.addColorStop(0.82,'#f7c98b');
    sky.addColorStop(1,   '#ffe3b8');
    g.fillStyle = sky; g.fillRect(0, 0, W, H);
    const sunX = W * 0.63, sunY = H * 0.56, sunR = Math.min(W, H) * 0.075;
    const glow = g.createRadialGradient(sunX, sunY, 0, sunX, sunY, sunR * 4.2);
    glow.addColorStop(0, 'rgba(255,238,196,.95)');
    glow.addColorStop(0.35, 'rgba(255,203,140,.42)');
    glow.addColorStop(1, 'rgba(255,190,120,0)');
    g.fillStyle = glow; g.beginPath(); g.arc(sunX, sunY, sunR * 4.2, 0, Math.PI * 2); g.fill();
    g.fillStyle = '#fff2d2'; g.beginPath(); g.arc(sunX, sunY, sunR, 0, Math.PI * 2); g.fill();
    const r = makeRng(21);
    const layers = [
      { y: 0.62, amp: 0.075, col: '#7a5f7e', haze: 0.55 },
      { y: 0.70, amp: 0.095, col: '#4d3c5c', haze: 0.78 },
      { y: 0.79, amp: 0.075, col: '#2a2136', haze: 1 },
    ];
    layers.forEach((L, li) => {
      g.save(); g.globalAlpha = L.haze;
      g.fillStyle = L.col;
      g.beginPath(); g.moveTo(0, H);
      const base = H * L.y, amp = H * L.amp;
      g.lineTo(0, base);
      const steps = 9 + li * 2;
      for (let i = 1; i <= steps; i++){
        const x = (W / steps) * i;
        const y = base - amp * (0.35 + r() * 0.95) * (i % 2 ? 0.7 : 1);
        g.lineTo(x, y);
      }
      g.lineTo(W, H); g.closePath(); g.fill(); g.restore();
    });
    const water = g.createLinearGradient(0, H * 0.78, 0, H);
    water.addColorStop(0, '#3b3550'); water.addColorStop(1, '#171426');
    g.fillStyle = water; g.fillRect(0, H * 0.78, W, H * 0.22);
    for (let i = 0; i < 26; i++){
      const y = H * 0.80 + (H * 0.19) * (i / 26);
      const w = W * (0.10 + (i / 26) * 0.24) * (0.5 + r());
      g.fillStyle = `rgba(255,206,150,${0.30 - i * 0.009})`;
      g.fillRect(sunX - w / 2, y, w, Math.max(1.2, H * 0.004));
    }
    paperGrain(g, W, H, 0.045, 3);
  },

  coast(g, W, H){
    const sky = g.createLinearGradient(0, 0, 0, H * 0.52);
    sky.addColorStop(0, '#bcd9e4'); sky.addColorStop(0.6, '#e9e3d6'); sky.addColorStop(1, '#f7f2e6');
    g.fillStyle = sky; g.fillRect(0, 0, W, H * 0.52);
    const sea = g.createLinearGradient(0, H * 0.52, 0, H);
    sea.addColorStop(0, '#2f7d8c'); sea.addColorStop(0.45, '#1d5b76'); sea.addColorStop(1, '#0a2f47');
    g.fillStyle = sea; g.fillRect(0, H * 0.52, W, H * 0.48);
    g.fillStyle = 'rgba(255,255,255,.55)'; g.fillRect(0, H * 0.516, W, Math.max(1.5, H * 0.004));
    const glare = g.createRadialGradient(W * 0.76, H * 0.34, 0, W * 0.76, H * 0.34, Math.min(W, H) * 0.42);
    glare.addColorStop(0, 'rgba(255,246,222,.85)'); glare.addColorStop(1, 'rgba(255,246,222,0)');
    g.fillStyle = glare; g.fillRect(0, 0, W, H * 0.7);
    const r = makeRng(77);
    for (let i = 0; i < 9; i++){
      const y = H * (0.56 + i * 0.048);
      g.strokeStyle = `rgba(255,255,255,${0.42 - i * 0.035})`;
      g.lineWidth = Math.max(1.5, H * (0.006 - i * 0.0004));
      g.beginPath();
      for (let x = -20; x <= W + 20; x += 14){
        const yy = y + Math.sin(x / (W / (7 + i)) * Math.PI * 2 + i) * H * 0.016 * (1 + i * 0.12) + (r() - 0.5) * 2;
        x === -20 ? g.moveTo(x, yy) : g.lineTo(x, yy);
      }
      g.stroke();
    }
    g.fillStyle = 'rgba(255,255,255,.16)';
    g.beginPath(); g.moveTo(0, H * 0.90);
    for (let x = 0; x <= W; x += 20) g.lineTo(x, H * 0.90 + Math.sin(x / 90) * H * 0.01);
    g.lineTo(W, H); g.lineTo(0, H); g.closePath(); g.fill();
    paperGrain(g, W, H, 0.05, 11);
  },

  botanical(g, W, H){
    g.fillStyle = '#f4efe4'; g.fillRect(0, 0, W, H);
    const r = makeRng(5);
    const tones = ['#61744f', '#7c8f68', '#94a67e', '#4b5c3d'];
    for (let s = 0; s < 4; s++){
      const baseX = W * (0.16 + s * 0.22) + (r() - 0.5) * W * 0.05;
      const topX = baseX + (r() - 0.5) * W * 0.18;
      const topY = H * (0.06 + r() * 0.10);
      g.strokeStyle = '#5b6b4a'; g.lineWidth = Math.max(2, W * 0.005);
      g.beginPath(); g.moveTo(baseX, H * 1.02);
      g.bezierCurveTo(baseX + (r() - 0.5) * W * 0.1, H * 0.7, topX + (r() - 0.5) * W * 0.1, H * 0.36, topX, topY);
      g.stroke();
      const n = 6 + Math.round(r() * 3);
      for (let i = 0; i < n; i++){
        const t = 0.12 + (i / n) * 0.82;
        const x = baseX + (topX - baseX) * t + (r() - 0.5) * W * 0.05;
        const y = H * 1.02 + (topY - H * 1.02) * t;
        const dir = i % 2 ? 1 : -1;
        const len = Math.min(W, H) * (0.10 + r() * 0.06);
        const ang = (-Math.PI / 2) + dir * (0.75 + r() * 0.35);
        const col = tones[Math.floor(r() * tones.length)];
        g.save(); g.translate(x, y); g.rotate(ang);
        g.fillStyle = col; g.globalAlpha = 0.85;
        g.beginPath();
        g.moveTo(0, 0);
        g.bezierCurveTo(len * 0.35, -len * 0.30, len * 0.75, -len * 0.26, len, 0);
        g.bezierCurveTo(len * 0.75, len * 0.26, len * 0.35, len * 0.30, 0, 0);
        g.fill();
        g.globalAlpha = 0.5; g.strokeStyle = '#3f4c33'; g.lineWidth = Math.max(0.8, W * 0.0016);
        g.beginPath(); g.moveTo(0, 0); g.lineTo(len * 0.95, 0); g.stroke();
        g.restore();
      }
    }
    paperGrain(g, W, H, 0.06, 23);
  },

  bauhaus(g, W, H){
    g.fillStyle = '#f7f3ea'; g.fillRect(0, 0, W, H);
    const pal = ['#1f2933', '#c1502e', '#e3b23c', '#3a6b6b', '#8d6748', '#d9d3c6'];
    const r = makeRng(42);
    const cols = 4, rows = 5;
    const cw = W / cols, ch = H / rows;
    for (let iy = 0; iy < rows; iy++){
      for (let ix = 0; ix < cols; ix++){
        const x = ix * cw, y = iy * ch;
        const kind = Math.floor(r() * 5);
        const col = pal[Math.floor(r() * pal.length)];
        g.fillStyle = col;
        if (kind === 0){
          g.beginPath(); g.arc(x + cw / 2, y + ch / 2, Math.min(cw, ch) * 0.38, 0, Math.PI * 2); g.fill();
        } else if (kind === 1){
          g.beginPath(); g.moveTo(x + cw * 0.14, y + ch * 0.86);
          g.lineTo(x + cw * 0.86, y + ch * 0.86); g.lineTo(x + cw * 0.5, y + ch * 0.16); g.closePath(); g.fill();
        } else if (kind === 2){
          g.beginPath(); g.moveTo(x + cw * 0.5, y + ch * 0.5);
          g.arc(x + cw * 0.5, y + ch * 0.5, Math.min(cw, ch) * 0.42, Math.PI, Math.PI * 1.5); g.closePath(); g.fill();
        } else if (kind === 3){
          g.fillRect(x + cw * 0.2, y + ch * 0.32, cw * 0.6, ch * 0.36);
        } else {
          g.lineWidth = Math.min(cw, ch) * 0.07;
          g.strokeStyle = col;
          g.beginPath(); g.arc(x + cw / 2, y + ch / 2, Math.min(cw, ch) * 0.3, 0, Math.PI * 2); g.stroke();
        }
      }
    }
    g.strokeStyle = 'rgba(31,41,51,.16)'; g.lineWidth = Math.max(1, W * 0.0016);
    for (let i = 1; i < cols; i++){ g.beginPath(); g.moveTo(i * cw, 0); g.lineTo(i * cw, H); g.stroke(); }
    for (let i = 1; i < rows; i++){ g.beginPath(); g.moveTo(0, i * ch); g.lineTo(W, i * ch); g.stroke(); }
    paperGrain(g, W, H, 0.05, 63);
  },

  ink(g, W, H){
    g.fillStyle = '#fbfaf6'; g.fillRect(0, 0, W, H);
    const r = makeRng(88);
    for (let i = 0; i < 9; i++){
      const x0 = W * (0.08 + r() * 0.7), y0 = H * (0.12 + r() * 0.7);
      const dx = (r() - 0.5) * W * 0.45, dy = (r() - 0.5) * H * 0.3;
      g.strokeStyle = `rgba(${28 + Math.round(r()*40)},${34 + Math.round(r()*36)},${58 + Math.round(r()*40)},${0.10 + r() * 0.26})`;
      g.lineWidth = Math.min(W, H) * (0.02 + r() * 0.06);
      g.lineCap = 'round';
      g.beginPath(); g.moveTo(x0, y0);
      g.bezierCurveTo(x0 + dx * 0.4, y0 - dy, x0 + dx * 0.7, y0 + dy * 1.2, x0 + dx, y0 + dy * 0.3);
      g.stroke();
    }
    for (let i = 0; i < 4; i++){
      g.strokeStyle = `rgba(24,28,44,${0.35 + r() * 0.4})`;
      g.lineWidth = Math.max(1.4, W * 0.0025);
      const y = H * (0.25 + i * 0.16) + (r() - 0.5) * H * 0.03;
      g.beginPath(); g.moveTo(W * 0.10, y);
      g.bezierCurveTo(W * 0.4, y - H * 0.05, W * 0.62, y + H * 0.05, W * 0.9, y);
      g.stroke();
    }
    for (let i = 0; i < 60; i++){
      g.fillStyle = `rgba(30,34,52,${0.05 + r() * 0.28})`;
      const rad = Math.min(W, H) * (0.001 + r() * 0.008);
      g.beginPath(); g.arc(r() * W, r() * H, rad, 0, Math.PI * 2); g.fill();
    }
    paperGrain(g, W, H, 0.06, 5);
  },

  portrait(g, W, H){
    const bg = g.createLinearGradient(0, 0, W, H);
    bg.addColorStop(0, '#d8b6a4'); bg.addColorStop(0.5, '#a8787a'); bg.addColorStop(1, '#3f2a35');
    g.fillStyle = bg; g.fillRect(0, 0, W, H);
    const halo = g.createRadialGradient(W * 0.62, H * 0.30, 0, W * 0.62, H * 0.30, Math.min(W, H) * 0.6);
    halo.addColorStop(0, 'rgba(255,238,214,.55)'); halo.addColorStop(1, 'rgba(255,238,214,0)');
    g.fillStyle = halo; g.fillRect(0, 0, W, H);
    const cx = W * 0.5, headR = Math.min(W, H) * 0.115, headY = H * 0.42;
    g.fillStyle = '#241a22';
    g.beginPath();
    g.moveTo(cx - W * 0.46, H * 1.02);
    g.bezierCurveTo(cx - W * 0.30, H * 0.80, cx - headR * 1.5, H * 0.66, cx - headR * 0.95, headY + headR * 0.75);
    g.bezierCurveTo(cx - headR * 1.15, headY - headR * 3.2, cx + headR * 1.15, headY - headR * 3.2, cx + headR * 0.95, headY + headR * 0.75);
    g.bezierCurveTo(cx + headR * 1.5, H * 0.66, cx + W * 0.30, H * 0.80, cx + W * 0.46, H * 1.02);
    g.closePath(); g.fill();
    g.save(); g.globalCompositeOperation = 'lighter';
    g.strokeStyle = 'rgba(255,206,158,.75)'; g.lineWidth = Math.max(3, W * 0.008);
    g.beginPath();
    g.moveTo(cx + headR * 0.95, headY + headR * 0.6);
    g.bezierCurveTo(cx + headR * 1.5, H * 0.66, cx + W * 0.30, H * 0.80, cx + W * 0.46, H * 1.02);
    g.stroke();
    g.beginPath(); g.arc(cx, headY, headR, -Math.PI * 0.45, Math.PI * 0.35); g.stroke();
    g.restore();
    paperGrain(g, W, H, 0.05, 31);
  },
};
const SAMPLE_LABELS = {
  sunrise:'Golden Hour', coast:'Coastline', botanical:'Botanical',
  bauhaus:'Bauhaus', ink:'Ink Wash', portrait:'Portrait',
};
/* Only the first four samples are shown, in a single row. */
const SAMPLE_KEYS = Object.keys(ART).slice(0, 4);

/* Render artwork into a canvas with the given aspect ratio (cover crop). */
function renderArtworkCanvas(kind, outW, outH, sourceImage){
  const c = document.createElement('canvas');
  c.width = Math.max(320, Math.round(outW));
  c.height = Math.max(320, Math.round(outH));
  const g = c.getContext('2d');
  if (kind === 'image' && sourceImage){
    const iw = sourceImage.naturalWidth || sourceImage.width;
    const ih = sourceImage.naturalHeight || sourceImage.height;
    const s = Math.max(c.width / iw, c.height / ih);      // cover
    const dw = iw * s, dh = ih * s;
    g.imageSmoothingQuality = 'high';
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
    g.drawImage(sourceImage, (c.width - dw) / 2, (c.height - dh) / 2, dw, dh);
  } else {
    (ART[kind] || ART.sunrise)(g, c.width, c.height);
  }
  return c;
}
function thumbDataUrl(kind, w = 220, h = 275){
  const c = renderArtworkCanvas(kind, w, h, null);
  return c.toDataURL('image/jpeg', 0.78);
}

/* ============================================================
   Scene build
   ============================================================ */
const hang = new THREE.Group();
hang.position.z = 0.06;
scene.add(hang);

/* The print texture is created once per distinct artwork canvas; the canvas
   itself is memoised so repeated rebuilds do not repaint the artwork. */
let artTexture = null;
let artCache = { key:'', canvas:null };
let pendingImage = null;   // decoded HTMLImageElement for uploaded / URL artwork

function disposeTree(node){
  node.traverse(o => {
    if (o.geometry) o.geometry.dispose();
    if (o.material){
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach(m => {
        for (const k of ['map','roughnessMap','alphaMap','normalMap']){
          const t = m[k];
          if (t && t !== roughnessNoise && t !== artTexture && t !== f35Grain && t !== l01OakGrain && t !== l03CharcoalGrain && t !== l04BlackGrain && t !== f36Grain && t !== f66Grain && t !== f85Ornament && t !== f98Ornament && t !== f98SilverOrnament && t !== f91Ornament && t !== f91SideGrain && t !== f92Grain) t.dispose();
        }
        m.dispose();
      });
    }
  });
  node.clear();
}

/* dimensions of the current configuration, in inches */
function currentDims(){
  const m = SIZE_RE.exec(state.size) || [null, '24', '16'];
  return { W: parseFloat(m[1]), H: parseFloat(m[2]) };
}

function artworkEdgeTexture(source, edge, artW, artH){
  const vertical=edge==='left'||edge==='right';
  const strip=Math.max(2,Math.round(vertical ? source.width/artW : source.height/artH));
  const sx=edge==='right' ? source.width-strip : 0;
  const sy=edge==='bottom' ? source.height-strip : 0;
  const sw=vertical ? strip : source.width;
  const sh=vertical ? source.height : strip;
  const c=document.createElement('canvas');
  c.width=sw;c.height=sh;
  c.getContext('2d').drawImage(source,sx,sy,sw,sh,0,0,sw,sh);
  const texture=new THREE.CanvasTexture(c);
  texture.colorSpace=THREE.SRGBColorSpace;
  texture.anisotropy=renderer.capabilities.getMaxAnisotropy();
  return texture;
}

function buildScene(){
  disposeTree(hang);

  const { W, H } = currentDims();
  const spec = FRAME_BY_CODE[state.frame];
  const E = Math.max(W, H);

  /* --- frame moulding, stacked layers or a dedicated wood profile --- */
  let offset = 0;
  const stepBack = 0.085;
  if (spec.code === 'F35'){
    buildF35(W, H);
    offset = spec.face;
  } else if (spec.code === 'F36'){
    buildF36(W, H);
    offset = spec.face;
  } else if (spec.code === 'F66'){
    buildF66(W, H);
    offset = spec.face;
  } else if (spec.code === 'F84'){
    buildF84(W, H);
    offset = spec.face;
  } else if (spec.code === 'F85' || spec.code === 'F82'){
    buildF85(W, H);
    offset = spec.face;
  } else if (spec.code === 'F91'){
    buildF91(W,H);
    offset = spec.face;
  } else if (spec.code === 'F92'){
    buildF92(W,H);
    offset = spec.face;
  } else if (spec.code === 'F93'){
    buildF93(W,H);
    offset = spec.face;
  } else if (spec.code === 'F94'){
    buildF93(W,H,F94_BLACK_SILVER_PROFILE);
    offset = spec.face;
  } else if (spec.code === 'F97'){
    buildF97(W,H);
    offset = spec.face;
  } else if (spec.code === 'F98'){
    buildF97(W,H,true);
    offset = spec.face;
  } else if (spec.code === 'L01'){
    buildL01(W,H);
    offset = spec.face;
  } else if (spec.code === 'L08'){
    buildDarkWoodFrame(W,H,l03CharcoalGrain,false);
    offset = spec.face;
  } else if (spec.code === 'L09'){
    buildDarkWoodFrame(W,H,l04BlackGrain,true);
    offset = spec.face;
  } else {
    spec.layers.forEach((layer, i) => {
      const oW = W - 2 * offset, oH = H - 2 * offset;
      const iW = oW - 2 * layer.w, iH = oH - 2 * layer.w;
      const depth = Math.max(0.35, spec.depth - i * stepBack);
      const geo = ringGeometry(oW, oH, iW, iH, depth, 0.028);
      const mat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(layer.c),
        roughness: layer.r, metalness: layer.m,
        roughnessMap: roughnessNoise,
        envMapIntensity: layer.m > 0.4 ? 1.25 : 0.75,
      });
      const mesh = new THREE.Mesh(geo, mat);
      mesh.castShadow = true;
      mesh.receiveShadow = true;
      hang.add(mesh);
      offset += layer.w;
    });
  }

  const openingW = W - 2 * offset;
  const openingH = H - 2 * offset;

  /* --- print fills the opening (float frames leave a shadow gap) --- */
  const FLOAT_GAP = 0.30;
  const isFloat = !!spec.float;

  const isLShadowBox = spec.code === 'L01' || spec.code === 'L08' || spec.code === 'L09';
  const artZ = Math.max(0.12, isLShadowBox ? spec.depth
    : (spec.code === 'F97' || spec.code === 'F98') ? 0.64*F97_DEPTH_SCALE
    : (spec.code === 'F91' || spec.code === 'F92' || spec.code === 'F93' || spec.code === 'F94')
      ? 0.64 * F91_DEPTH_SCALE
    /* F36 sits the print right on the white liner, no well in front of it */
    : (spec.code === 'F36') ? 0.875
      : spec.depth - (isFloat ? 0.42 : 0.52));

  let artW = openingW, artH = openingH;
  if (isFloat){
    const gap = isLShadowBox ? 0.10 : FLOAT_GAP;
    artW = Math.max(2, openingW - 2 * gap);
    artH = Math.max(2, openingH - 2 * gap);
  }

  /* artwork — painted at the print's own aspect ratio, memoised */
  const px = 1500;
  const artKey = (state.art.kind === 'image' ? 'image:' + state.art.key : 'sample:' + state.art.key)
    + ':' + artW.toFixed(2) + 'x' + artH.toFixed(2);
  if (artCache.key !== artKey){
    artCache = {
      key: artKey,
      canvas: renderArtworkCanvas(
        state.art.kind === 'image' ? 'image' : state.art.key,
        px, px * (artH / artW),
        state.art.kind === 'image' ? pendingImage : null
      ),
    };
  }
  if (!artTexture || artTexture.image !== artCache.canvas){
    if (artTexture) artTexture.dispose();
    artTexture = new THREE.CanvasTexture(artCache.canvas);
    artTexture.colorSpace = THREE.SRGBColorSpace;
    artTexture.anisotropy = renderer.capabilities.getMaxAnisotropy();
  }
  artTexture.needsUpdate = true;

  const artMat = new THREE.MeshStandardMaterial({
    map: artTexture, roughness: 0.88, metalness: 0,
    envMapIntensity: 0.35,
  });
  const art = new THREE.Mesh(new THREE.PlaneGeometry(artW, artH), artMat);
  art.position.z = artZ;
  hang.add(art);

  const hasWrappedCanvas=isLShadowBox;
  if(hasWrappedCanvas){
    const wrapDepth=artZ;
    const edgeMaterial=edge=>new THREE.MeshStandardMaterial({
      map:artworkEdgeTexture(artCache.canvas,edge,artW,artH),
      roughness:0.88,metalness:0,side:THREE.DoubleSide,envMapIntensity:0.35,
    });
    const top=new THREE.Mesh(new THREE.PlaneGeometry(artW,wrapDepth),edgeMaterial('top'));
    top.rotation.x=Math.PI/2;top.position.set(0,artH/2,wrapDepth/2);hang.add(top);
    const bottom=new THREE.Mesh(new THREE.PlaneGeometry(artW,wrapDepth),edgeMaterial('bottom'));
    bottom.rotation.x=-Math.PI/2;bottom.position.set(0,-artH/2,wrapDepth/2);hang.add(bottom);
    const right=new THREE.Mesh(new THREE.PlaneGeometry(wrapDepth,artH),edgeMaterial('right'));
    right.rotation.y=-Math.PI/2;right.position.set(artW/2,0,wrapDepth/2);hang.add(right);
    const left=new THREE.Mesh(new THREE.PlaneGeometry(wrapDepth,artH),edgeMaterial('left'));
    left.rotation.y=Math.PI/2;left.position.set(-artW/2,0,wrapDepth/2);hang.add(left);
    [top,bottom,right,left].forEach(side=>{side.castShadow=true;side.receiveShadow=true;});
    const back=new THREE.Mesh(new THREE.PlaneGeometry(artW,artH),
      new THREE.MeshStandardMaterial({color:0xe6e0d7,roughness:0.94,side:THREE.DoubleSide}));
    back.position.z=0;hang.add(back);
  }

  /* --- grounding: tight contact halo + soft offset drop shadow --- */
  hang.add(shadowCard(W, H, openingW, openingH, 14, 1.8, 0.46, 0.5, -0.7));
  hang.add(shadowCard(W, H, openingW, openingH, 44, 3.4, 0.34, 2.8, -2.1));

  /* --- lights follow the frame size --- */
  key.position.set(-0.85 * E, 1.15 * E, 1.5 * E);
  key.target.position.set(0, 0, 0);
  key.shadow.camera.left = -0.95 * E; key.shadow.camera.right = 0.95 * E;
  key.shadow.camera.top = 0.95 * E;   key.shadow.camera.bottom = -0.95 * E;
  key.shadow.camera.near = 0.05 * E;  key.shadow.camera.far = 8 * E;
  key.shadow.camera.updateProjectionMatrix();

  fill.position.set(1.25 * E, 0.25 * E, 1.1 * E);
  fill.target.position.set(0, 0, 0);

  controls.minDistance = Math.max(4, 0.28 * E);
  controls.maxDistance = Math.max(30, 4.2 * E);

  /* refresh the picture-in-picture still (see the Boot section) */
  if (typeof requestPipShot === 'function') requestPipShot();
}

/* ============================================================
   Camera presets
   ============================================================ */
const VIEWS = ['straight', 'angle', 'angle-left', 'top', 'detail'];
/* how much air to leave around the frame; the fullscreen overlay is a "look
   closely" mode, so it fills far more of the available space */
let fitMargin = 1.28;
function viewTargets(name){
  const { W, H } = currentDims();
  const spec = FRAME_BY_CODE[state.frame];
  const vFov = camera.fov * Math.PI / 180;
  const fitH = (H / 2) / Math.tan(vFov / 2);
  const fitW = (W / 2) / (Math.tan(vFov / 2) * camera.aspect);
  /* 1.28 leaves room for the drop shadow, which reaches ~4in past the moulding */
  const D = Math.max(fitH, fitW) * fitMargin;
  if (name === 'straight') return { pos:new THREE.Vector3(0, 0, D), tgt:new THREE.Vector3(0, 0, spec.depth * 0.4) };
  if (name === 'detail'){
    const isF35 = spec.code === 'F35';
    const isRightCorner = spec.code === 'F36' || spec.code === 'F66' || spec.code === 'F84' || spec.code === 'F85' || spec.code === 'F91' || spec.code === 'F92' || spec.code === 'F93' || spec.code === 'F94' || spec.code === 'F97' || spec.code === 'F98' || spec.code === 'L01' || spec.code === 'L08' || spec.code === 'L09';
    const isClose = isF35 || isRightCorner;
    const apex = new THREE.Vector3(isRightCorner ? W/2 : -W/2, H/2, spec.depth*0.5);
    const target = isClose
      ? apex.clone().add(new THREE.Vector3((isRightCorner ? -1 : 1)*1.55*spec.face,
                                           -1.55*spec.face, 0))
      : apex;
    const d = ((isClose ? 4.8 : 9.5) * spec.face) / (2 * Math.tan(vFov / 2));
    const dir = new THREE.Vector3(spec.code === 'F66' || spec.code === 'F85' || spec.code === 'F97' || spec.code === 'F98' || spec.code === 'L01' || spec.code === 'L08' || spec.code === 'L09' ? 0.70 : isRightCorner ? 0.38 : -0.38,
                                  0.26, 1).normalize();
    return { pos: target.clone().add(dir.multiplyScalar(d)), tgt: target };
  }
  if (name === 'top')
    return { pos:new THREE.Vector3(0.16 * D, 0.58 * D, 0.80 * D),
             tgt:new THREE.Vector3(0, 0, spec.depth * 0.4) };
  if (name === 'angle-left'){
    /* the same three-quarter view, mirrored — the two thumbnails have to differ */
    const v = viewTargets('angle');
    v.pos.x *= -1;
    return v;
  }
  if (spec.code === 'F36' || spec.code === 'F66' || spec.code === 'F84' || spec.code === 'F85' || spec.code === 'F91' || spec.code === 'F92' || spec.code === 'F93' || spec.code === 'F94' || spec.code === 'F97' || spec.code === 'F98' || spec.code === 'L01' || spec.code === 'L08' || spec.code === 'L09')
    return { pos:new THREE.Vector3(0.46*D, 0.12*D, 0.90*D),
             tgt:new THREE.Vector3(0, 0, spec.depth*0.4) };
  return { pos:new THREE.Vector3(-0.46 * D, 0.12 * D, 0.90 * D), tgt:new THREE.Vector3(0, 0, spec.depth * 0.4) };
}
let camTween = null;
function goToView(name, instant){
  const { pos, tgt } = viewTargets(name);
  if (instant){
    camera.position.copy(pos);
    controls.target.copy(tgt);
    controls.update();
    camTween = null;
    return;
  }
  camTween = {
    t: 0,
    fromPos: camera.position.clone(), toPos: pos,
    fromTgt: controls.target.clone(), toTgt: tgt,
  };
}
function stepCamera(dt){
  if (!camTween) return;
  camTween.t = Math.min(1, camTween.t + dt / 0.65);
  const e = 1 - Math.pow(1 - camTween.t, 3);
  camera.position.lerpVectors(camTween.fromPos, camTween.toPos, e);
  controls.target.lerpVectors(camTween.fromTgt, camTween.toTgt, e);
  if (camTween.t >= 1){
    camTween = null;
    if (typeof requestPipShot === 'function') requestPipShot();
  }
}

/* ============================================================
   UI
   ============================================================ */
const $  = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const el = {
  dimW:       $('#dim-w'),
  dimH:       $('#dim-h'),
  swap:       $('#size-swap'),
  presets:    $('#size-presets'),
  frameGrid:  $('#frame-grid'),
  thumbs:     $('#thumbs'),
  price:      $('#price'),
  priceDesc:  $('#price-desc'),
  chipSize:   $('#chip-size'),
  chipFrame:  $('#chip-frame'),
  sizeValue:  $('#size-value'),
  frameValue: $('#frame-value'),
  artValue:   $('#art-value'),
  atc:        $('#atc'),
  toast:      $('#toast'),
};

const prettySize = s => { const m = SIZE_RE.exec(s); return m ? `${m[1]} × ${m[2]} in` : s; };
const orientOf = (W, H) => (W === H ? 'Square' : W > H ? 'Landscape' : 'Portrait');
/* Sellable size box: longest side 10–40 in, shortest side 8–32 in.
   Same rule as the Shopify variant table, so every size the preview allows is
   a size that actually exists as a variant (largest 40 × 32, smallest 10 × 8).
   Above 37 × 30 only four mouldings are produced, so those sizes carry their
   own cap and the other eleven frames are locked out. 37 × 30 itself is fine. */
const BIG_LONG_MAX = 37, BIG_SHORT_MAX = 30;
const BIG_ONLY_FRAMES = ['F91', 'F92', 'F93', 'F94'];
const isBigSize = (long, short) => long > BIG_LONG_MAX || short > BIG_SHORT_MAX;
const frameAllowsSize = (code, long, short) =>
  !isBigSize(long, short) || BIG_ONLY_FRAMES.indexOf(code) !== -1;
const clampDims = (w, h, code) => {
  let W = Math.round(Number(w)), H = Math.round(Number(h));
  if (!Number.isFinite(W)) W = 12;
  if (!Number.isFinite(H)) H = 12;
  const capped = code && BIG_ONLY_FRAMES.indexOf(code) === -1;
  const long = Math.min(capped ? BIG_LONG_MAX : LONG_MAX, Math.max(LONG_MIN, Math.max(W, H)));
  const short = Math.min(capped ? BIG_SHORT_MAX : SHORT_MAX, Math.max(SHORT_MIN, Math.min(W, H)));
  return W >= H ? [long, short] : [short, long];
};

function toast(msg){
  el.toast.textContent = msg;
  el.toast.classList.add('is-on');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => el.toast.classList.remove('is-on'), 2600);
}

/* ---- size ---- */
function paintPresets(){
  $$('#size-presets .preset').forEach(b => b.classList.toggle('is-active', b.dataset.size === state.size));
}
function paintFrameSelection(){
  $$('#frame-grid .fcard').forEach(x => x.classList.toggle('is-active', x.dataset.code === state.frame));
}
/* Grey out the frames that are not produced at the current size. The card stays
   clickable on purpose: clicking it explains the cap and shrinks the size. */
function refreshFrameLocks(){
  const { W, H } = currentDims();
  const long = Math.max(W, H), short = Math.min(W, H);
  $$('#frame-grid .fcard').forEach(b => {
    const ok = frameAllowsSize(b.dataset.code, long, short);
    b.classList.toggle('is-locked', !ok);
    const label = b.dataset.label || '';
    b.title = ok ? label : `${label} — largest ${BIG_LONG_MAX}×${BIG_SHORT_MAX} in`;
    if (ok) b.removeAttribute('aria-label');
    else b.setAttribute('aria-label', `${label}, unavailable above ${BIG_LONG_MAX}×${BIG_SHORT_MAX} in`);
  });
}
function setSize(w, h, syncInputs = true){
  const [cw, ch] = clampDims(w, h);
  const long = Math.max(cw, ch), short = Math.min(cw, ch);
  if (!frameAllowsSize(state.frame, long, short)){
    state.frame = BIG_ONLY_FRAMES[0];
    paintFrameSelection();
    toast(`Over ${BIG_LONG_MAX}×${BIG_SHORT_MAX} in is only made in F91/F92/F93/F94 — frame switched to ${state.frame}.`);
  }
  state.size = `${cw}x${ch}`;
  if (syncInputs){
    el.dimW.value = cw;
    el.dimH.value = ch;
  }
  paintPresets();
  refreshFrameLocks();
  buildScene();
  updateSummary();
  goToView(currentView(), false);
}
function buildPresets(){
  el.presets.innerHTML = '';
  const list = presetsSwapped
    ? SIZE_PRESETS.map(s => { const p = s.split('x'); return p[1] + 'x' + p[0]; })
    : SIZE_PRESETS;
  list.forEach(size => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'preset';
    b.dataset.size = size;
    b.innerHTML = size.replace('x', '×');
    b.addEventListener('click', () => {
      const [w, h] = size.split('x').map(Number);
      setSize(w, h);
    });
    el.presets.appendChild(b);
  });
  paintPresets();
}

/* Swap every width/height pair: the dim inputs, the preset chips and the preview. */
let presetsSwapped = false;
function swapSizes(){
  const { W, H } = currentDims();
  presetsSwapped = !presetsSwapped;
  buildPresets();
  setSize(H, W);
}

function swatchShadow(spec){
  const total = spec.layers.reduce((a, l) => a + l.w, 0);
  const budget = 13;
  let acc = 0;
  return spec.layers.map(l => {
    acc += Math.max(2, Math.round(budget * l.w / total));
    const hex = '#' + l.c.toString(16).padStart(6, '0');
    return `inset 0 0 0 ${acc}px ${hex}`;
  }).join(', ');
}
function buildFrameGrid(){
  el.frameGrid.innerHTML = '';
  FRAMES.forEach(f => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'fcard' + (f.code === state.frame ? ' is-active' : '');
    b.dataset.code = f.code;
    b.dataset.label = `${f.name} · ${f.material}`;
    b.title = b.dataset.label;
    /* 15 local thumbnails of 11–26 KB each: load them eagerly. `loading="lazy"`
       left the cards blank until they were scrolled near, which looks broken in
       a grid that is usually on screen already. */
    const thumb = (VARIANT_BOOT.thumbs || {})[f.code] || '';
    const sw = document.createElement('span');
    sw.className = 'fcard__sw';
    const img = document.createElement('img');
    if (thumb) { img.src = thumb; }
    else { sw.classList.add('is-missing'); sw.textContent = f.code; }
    img.alt = '';
    img.decoding = 'async';
    img.addEventListener('error', () => {
      /* folder missing / file renamed: fall back to the frame code, never a
         blank grey box */
      sw.classList.add('is-missing');
      sw.textContent = f.code;
    });
    sw.appendChild(img);
    const label = document.createElement('span');
    label.className = 'fcard__name';
    label.textContent = f.name;
    b.append(sw, label);
    b.addEventListener('click', () => {
      const { W, H } = currentDims();
      state.frame = f.code;
      paintFrameSelection();
      /* frame intent wins over size: shrink the size to this moulding's cap */
      const [cw, ch] = clampDims(W, H, f.code);
      if (`${cw}x${ch}` !== state.size){
        toast(`${f.code} stops at ${BIG_LONG_MAX}×${BIG_SHORT_MAX} in — size set to ${cw}×${ch}.`);
        setSize(cw, ch);
      } else {
        refreshFrameLocks();
        buildScene();
        updateSummary();
        goToView(currentView(), false);
      }
    });
    el.frameGrid.appendChild(b);
  });
  refreshFrameLocks();
}

function buildThumbs(){
  el.thumbs.innerHTML = '';
  SAMPLE_KEYS.forEach(k => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'thumb' + (state.art.kind === 'sample' && state.art.key === k ? ' is-active' : '');
    b.innerHTML = `<img alt="${SAMPLE_LABELS[k]}" src="${thumbDataUrl(k)}">`;
    b.title = SAMPLE_LABELS[k];
    b.addEventListener('click', () => {
      state.art = { kind:'sample', key:k };
      pendingImage = null;
      buildThumbs();
      buildScene();
      el.artValue.textContent = SAMPLE_LABELS[k];
    });
    el.thumbs.appendChild(b);
  });
}

function setViewButtons(name){
  $$('.stage__views button').forEach(b => b.classList.toggle('is-active', b.dataset.view === name));
}
const currentView = () => ($('.stage__views button.is-active') || {}).dataset?.view || 'angle';

/* ============================================================
   Angle thumbnails
   ------------------------------------------------------------
   One live render per preset, so each thumbnail shows the frame, size and art
   that are on screen right now. Rendered into an offscreen target: touching the
   visible canvas would flash the thumb's angle before the camera is restored.
   ============================================================ */
let thumbTimer = null;
function scheduleAngleThumbs(){
  clearTimeout(thumbTimer);
  thumbTimer = setTimeout(buildAngleThumbs, 260);
}
function buildAngleThumbs(){
  const host = $('.stage__views');
  if (!host || !renderer || !scene) return;
  const S = 120;
  const rt = new THREE.WebGLRenderTarget(S, S, { colorSpace: THREE.SRGBColorSpace });
  const buf = new Uint8Array(S * S * 4);
  const sheet = document.createElement('canvas');
  sheet.width = sheet.height = S;
  const ctx = sheet.getContext('2d');
  const img = ctx.createImageData(S, S);

  const keep = {
    pos: camera.position.clone(),
    tgt: controls.target.clone(),
    aspect: camera.aspect,
    alpha: renderer.getClearAlpha(),
  };
  /* square thumbs need a square frustum, otherwise the frame is fitted to the
     stage's wide aspect and sits small in the middle */
  camera.aspect = 1;
  camera.updateProjectionMatrix();
  renderer.setClearAlpha(0);

  VIEWS.forEach(name => {
    const t = viewTargets(name);
    camera.position.copy(t.pos);
    camera.lookAt(t.tgt);
    renderer.setRenderTarget(rt);
    renderer.clear();
    renderer.render(scene, camera);
    renderer.readRenderTargetPixels(rt, 0, 0, S, S, buf);

    /* WebGL hands rows back bottom-up */
    for (let y = 0; y < S; y++){
      const from = (S - 1 - y) * S * 4;
      img.data.set(buf.subarray(from, from + S * 4), y * S * 4);
    }
    ctx.putImageData(img, 0, 0);

    const thumb = host.querySelector(`button[data-view="${name}"] img`);
    if (thumb) thumb.src = sheet.toDataURL('image/png');
  });

  renderer.setRenderTarget(null);
  renderer.setClearAlpha(keep.alpha);
  camera.aspect = keep.aspect;
  camera.updateProjectionMatrix();
  camera.position.copy(keep.pos);
  camera.lookAt(keep.tgt);
  rt.dispose();
}

/* ============================================================
   Summary
   ============================================================ */
function currentSku(){
  const { W, H } = currentDims();
  const pad = n => (n < 10 ? '0' + n : String(n));
  return 'FRAME' + state.frame + pad(W) + pad(H);
}
function updateSummary(){
  const { W, H } = currentDims();
  const spec = FRAME_BY_CODE[state.frame];
  const entry = priceEntry(state.size, state.frame);
  const isFloat = !!spec.float;

  el.price.textContent = entry ? money(entry.total) : 'On request';
  el.price.style.fontSize = entry ? '' : '18px';
  if (entry) { el.atc.dataset.variant = entry.variantId; el.atc.disabled = false; }
  else { delete el.atc.dataset.variant; el.atc.disabled = true; }
  el.priceDesc.innerHTML = `<b>${W} × ${H} in</b> · ${spec.name}` +
    (isFloat ? ' · float frame' : '');

  el.chipSize.innerHTML = `${W} × ${H} in <small>${orientOf(W, H)}</small>`;
  el.chipFrame.textContent = spec.name;

  el.sizeValue.textContent = prettySize(state.size);
  el.frameValue.textContent = spec.name;
  scheduleAngleThumbs();
}

/* ============================================================
   Events
   ============================================================ */
/* typing / stepping the dimensions rebuilds the scene, debounced so a
   half-typed number does not repaint on every keystroke.
   Blurring a box commits BOTH boxes as they currently read — reading from state
   instead would throw away a value typed in the other box but not yet flushed
   by the debounce (type width, tab to height, width would snap back). */
let dimTimer = null;
function readDims(){
  const cur = currentDims();
  const w = parseInt(el.dimW.value, 10);
  const h = parseInt(el.dimH.value, 10);
  return [Number.isFinite(w) ? w : cur.W, Number.isFinite(h) ? h : cur.H];
}
function queueDimChange(){
  clearTimeout(dimTimer);
  dimTimer = setTimeout(() => {
    const [w, h] = readDims();
    setSize(w, h, false);   // leave the boxes alone while the user is still typing
  }, 140);
}
function commitDimChange(){
  clearTimeout(dimTimer);
  const [w, h] = readDims();
  setSize(w, h, true);      // blur: clamp and normalise both boxes
}
el.dimW.addEventListener('input', queueDimChange);
el.dimH.addEventListener('input', queueDimChange);
el.dimW.addEventListener('change', commitDimChange);
el.dimH.addEventListener('change', commitDimChange);
if (el.swap) el.swap.addEventListener('click', swapSizes);

$('.dims').addEventListener('click', e => {
  const b = e.target.closest('button[data-dim]');
  if (!b) return;
  const { W, H } = currentDims();
  const d = Number(b.dataset.delta);
  setSize(b.dataset.dim === 'w' ? W + d : W, b.dataset.dim === 'h' ? H + d : H);
});

/* The camera view switch only exists in the theme section, not in this
   standalone preview page -- guard so the rest of the UI still boots. */
const stageViews = $('.stage__views');
if (stageViews) stageViews.addEventListener('click', e => {
  const b = e.target.closest('button[data-view]');
  if (!b) return;
  setViewButtons(b.dataset.view);
  goToView(b.dataset.view, false);
});

$('#file').addEventListener('change', e => {
  const f = e.target.files && e.target.files[0];
  if (!f) return;
  state.artFile = f; state.artName = f.name;
  const url = URL.createObjectURL(f);
  const img = new Image();
  img.onload = () => {
    pendingImage = img;
    state.art = { kind:'image', key:'upload' };
    artCache.key = '';
    buildThumbs();
    buildScene();
    el.artValue.textContent = f.name.length > 18 ? f.name.slice(0, 16) + '…' : f.name;
    toast('Artwork updated');
  };
  img.onerror = () => toast('Could not read that image');
  img.src = url;
});

$('#art-url-go').addEventListener('click', () => {
  const url = $('#art-url').value.trim();
  if (!url) return;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    pendingImage = img;
    state.art = { kind:'image', key:'url' };
    artCache.key = '';
    buildThumbs();
    buildScene();
    el.artValue.textContent = 'From URL';
    toast('Artwork loaded from URL');
  };
  img.onerror = () => toast('That image could not be loaded (CORS or bad URL)');
  img.src = url;
});

$('#atc').addEventListener('click', () => {
  const id = el.atc.dataset.variant;
  if (!id) return;
  const { W, H } = currentDims();
  const spec = FRAME_BY_CODE[state.frame];
  const props = {
    'Size': W + ' × ' + H + ' in',
    'Frame': state.frame + ' · ' + spec.name,
    'Artwork': state.artFile ? state.artName : (state.art.kind === 'sample' ? 'Sample' : 'From URL')
  };
  el.atc.disabled = true;
  const fail = msg => { el.atc.disabled = false; toast(msg); };

  let body, headers = { Accept: 'application/json' };
  if (state.artFile) {
    /* multipart, so the file lands on the order as a line item property */
    const fd = new FormData();
    fd.append('items[0][id]', String(id));
    fd.append('items[0][quantity]', '1');
    fd.append('items[0][properties][Size]', props.Size);
    fd.append('items[0][properties][Frame]', props.Frame);
    fd.append('items[0][properties][Artwork]', state.artFile, state.artName || 'artwork');
    body = fd;
  } else {
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props }] });
  }

  fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers, body })
    .then(r => r.text().then(t => {
      let b = null;
      try { b = t ? JSON.parse(t) : null; } catch (e) { /* non-JSON error page */ }
      if (!r.ok) {
        if (r.status === 413) throw new Error('Upload too large — try a smaller image.');
        throw new Error((b && (b.description || b.message)) || ('Cart error ' + r.status));
      }
      return b;
    }))
    .then(() => { window.location.href = '/cart'; })
    .catch(err => fail(err.message || 'Could not add to cart'));
});

/* ============================================================
   Boot
   ============================================================ */
function resize(){
  const r = stageEl.getBoundingClientRect();
  const w = Math.max(1, Math.round(r.width));
  const h = Math.max(1, Math.round(r.height));
  renderer.setSize(w, h, false);
  camera.aspect = w / h;
  camera.updateProjectionMatrix();
}
new ResizeObserver(resize).observe(stageEl);

/* ---- picture-in-picture + fullscreen preview ----------------------------
   Mobile only: the preview is a normal hero, so once it scrolls out of view a
   small still of the current config takes its place. Tapping it (or the ⤢
   button) moves the real stage into a fullscreen overlay — moving the canvas
   keeps its WebGL context, so the preview stays live and rotatable there. */
const pipEl = $('#pip');
const pipShot = $('#pip-shot');
const overlayEl = $('#overlay');
const slotEl = $('#stage-slot');
let stageHome = slotEl;
let pipPending = true;

function capturePip(){
  try {
    const shot = document.createElement('canvas');
    shot.width = 264;
    shot.height = 200;
    shot.getContext('2d').drawImage(canvas, 0, 0, shot.width, shot.height);
    pipShot.src = shot.toDataURL('image/jpeg', 0.72);
  } catch (_) {
    /* no readable buffer this frame — keep the previous still */
  }
}
function requestPipShot(){ pipPending = true; }

const isMobileLayout = () => window.matchMedia('(max-width:1024px)').matches;

new IntersectionObserver(entries => {
  const visible = entries[0].isIntersecting;
  const show = !visible && isMobileLayout() && !overlayEl.classList.contains('is-open');
  pipEl.classList.toggle('is-on', show);
  if (show) requestPipShot();
}, { threshold: 0 }).observe(slotEl);

function openOverlay(){
  if (overlayEl.classList.contains('is-open')) return;
  stageHome = stageEl.parentNode;
  overlayEl.appendChild(stageEl);
  overlayEl.classList.add('is-open');
  document.documentElement.style.overflow = 'hidden';
  pipEl.classList.remove('is-on');
  resize();
  fitMargin = 1.08;
  refitView();          // the frame must be re-fitted to the new (portrait, full-height) frame
  requestPipShot();
}
function closeOverlay(){
  if (!overlayEl.classList.contains('is-open')) return;
  overlayEl.classList.remove('is-open');
  stageHome.appendChild(stageEl);
  document.documentElement.style.overflow = '';
  resize();
  fitMargin = 1.28;
  refitView();
  requestPipShot();
}
/* recompute the camera for the current viewport aspect without animating */
function refitView(){ goToView(currentView(), true); }
$('#expand').addEventListener('click', openOverlay);
pipEl.addEventListener('click', openOverlay);
$('#overlay-close').addEventListener('click', closeOverlay);
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeOverlay(); });
window.addEventListener('resize', () => {
  if (!isMobileLayout()) pipEl.classList.remove('is-on');
});
window.addEventListener('orientationchange', () => setTimeout(refitView, 320));

buildThumbs();
buildPresets();
buildFrameGrid();
buildScene();
updateSummary();
resize();
goToView('angle', true);

let last = performance.now();
renderer.setAnimationLoop(now => {
  const dt = Math.min(0.05, (now - last) / 1000);
  last = now;
  stepCamera(dt);
  controls.update();
  renderer.render(scene, camera);
  /* read the drawing buffer in the same frame it was rendered, otherwise it
     may already be cleared */
  if (pipPending){
    pipPending = false;
    capturePip();
  }
});

/* hide the boot veil once the first frames are on screen */
requestAnimationFrame(() => requestAnimationFrame(() => {
  /* the boot veil only exists in the theme section, not in the preview page */
  const boot = $('#boot');
  if (boot) boot.classList.add('is-done');
}));

/* frame code → the array its builder actually sweeps. The Frame lab edits these,
   and saved edits in preview/frame-profiles.json land on the same arrays before
   the first buildScene(), so a saved frame looks the same on every load. */
const FRAME_PROFILE = {
  F35: F35_PROFILE, F36: F36_PROFILE, F66: F66_PROFILE, F84: F84_PROFILE,
  F82: F85_PROFILE, F85: F85_PROFILE,
  F91: F91_SHALLOW_PROFILE, F92: F92_WHITE_PROFILE,
  F93: F93_BLACK_GOLD_PROFILE, F94: F94_BLACK_SILVER_PROFILE,
  F97: F97_SHALLOW_PROFILE, F98: F97_SHALLOW_PROFILE,
  L01: L01_OAK_PROFILE, L08: L01_OAK_PROFILE, L09: L01_OAK_PROFILE,
};
Object.entries(PROFILES.overrides || {}).forEach(([code, saved]) => {
  const arr = FRAME_PROFILE[code];
  const pts = saved && saved.points;
  if (!arr || !Array.isArray(pts) || pts.length !== arr.length) return;
  pts.forEach((p, i) => { arr[i].r = p.r; arr[i].z = p.z; arr[i].c = p.c; });
  const spec = FRAME_BY_CODE[code];
  if (spec && Number.isFinite(saved.face)) spec.face = saved.face;
  if (spec && Number.isFinite(saved.depth)) spec.depth = saved.depth;
});

/* debug handle — handy when tuning the scene from the console.
   currentSku() is kept here (not in the UI) so the code↔SKU mapping can still be
   checked while wiring this into the theme. */
window.__studio = { THREE, renderer, scene, camera, controls, hang, state, setSize,
  key, fill, hemi, viewTargets, goToView, buildScene, artCache, currentSku,
  openOverlay, closeOverlay, requestPipShot,
  PROFILES, FRAMES, FRAME_BY_CODE, FRAME_PROFILE, updateSummary, SEAM };


/* variant table: loaded after the first paint so the scene shows immediately */
if (VARIANT_BOOT.variantsUrl) {
  fetch(VARIANT_BOOT.variantsUrl, { credentials: 'omit' })
    .then(r => r.json())
    .then(json => { VARIANT_MAP = json; updateSummary(); })
    .catch(() => {});
}
})();
